//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export namespace CwxBackend {
	export interface IDateRange
	{
		start: string;
		end: string;
	}
	export interface ICwxSelectListGroup
	{
		disabled: boolean;
		name: string;
	}
	export interface ICwxSelectListItem
	{
		disabled: boolean;
		group: CwxBackend.ICwxSelectListGroup;
		selected: boolean;
		text: string;
		value: string;
	}
	export interface ICustomLocaleDto
	{
		localeId: any;
		values: CwxBackend.ICustomLocaleValueDto[];
	}
	export interface ICustomLocaleValueDto
	{
		cultureCode: string;
		cultureCodeLabel: string;
		text: string;
	}
	export enum ESortDirection {
		Ascending = 0,
		Descending = 1
	}
	export enum ImageType {
		Profile = 0,
		Forecast = 2,
		ForecastOption = 4,
		News = 6,
		Survey = 12,
		Competition = 13,
		CompetitionAnswer = 14,
		Teaser = 15,
		Idea = 16,
		Challenge = 17,
		WebLink = 18,
		Panorama = 19,
		Space = 20
	}
	export interface ISystemSettingsDto
	{
		activationLinkHour: number;
		allowedRegisterDomains: string;
		areCategoriesVisibleInProfile: boolean;
		blogHomePageOn: boolean;
		companyEmailDomains: string;
		currencySigns: { [key:string]: string };
		defaultCurrencySign: string;
		emailStatusToReceiveStaffabaseNotifications: string;
		fromToken: string;
		globalReplyToAddress: string;
		invitingDailyLimit: number;
		isActivationEmail: boolean;
		isCreateForecastAvailable: boolean;
		isEmailRequiredDuringSelfRegistration: boolean;
		isForecastRankingShown: boolean;
		isInvitingActive: boolean;
		isMicrosoftTodoEnabled: boolean;
		isGraphSearchEnabled: boolean;
		isOnboardingTurnedOn: boolean;
		isPrivacyPolicyRequired: boolean;
		isProfileShown: boolean;
		isUserLoginInfoPageRequired: boolean;
		isUserRegistration: boolean;
		isUsernameShown: boolean;
		myItemsTexts: { [key:string]: string };
		onlyApiGeneratedUsersAreAllowedToRegister: boolean;
		onlyGlobalAndIdeaRolesCanSeeNames: boolean;
		staffbaseNotificationPrefix: string;
		supportEmail: string;
		tempErrorPagesLogoImageId: number;
		topPointsVisible: boolean;
		topSearchBoxVisible: boolean;
		topSubmitButtonTexts: { [key:string]: string };
		topSubmitButtonUrl: string;
		topSubmitButtonVisible: boolean;
		useRegistrationWhitelist: boolean;
		userDefaultFreeCash: number;
		userNavigationClosedCompetitionVisible: boolean;
		userNavigationIdeasVisible: boolean;
		userNavigationProfileVisible: boolean;
		userNavigationSettingsVisible: boolean;
		userNavigationTasksVisible: boolean;
		userProfileExternalIsEnabled: boolean;
		userProfileExternalLink: string;
		userProfileExternalLinkText: string;
		ssoEnabled: boolean;
		autoCompleteEnabled: boolean;
		allowAnonymousFeedback: boolean;
		isAutomaticTranslationServiceEnabled: boolean;
		isHiddenCustomContentOnLoginPage: boolean;
		allowedFileExtensions: string;
		maximumFileSize: number;
		isUserAllowedToChangeFrontEnd: boolean;
		footerMenuViewModel: CwxBackend.IFooterMenuViewModel;
		canUserGenerateTags: boolean;
		areUserProfileTagsClickable: boolean;
		isAiEnabled: boolean;
		isHotjarEnabled: boolean;
		hotjarSiteId: string;
		automaticItemDeletionEnabled: boolean;
		automaticItemDeletionDaysAfterDate: number;
		automaticUserDeletionEnabled: boolean;
		automaticUserDeletionDaysAfterDate: number;
		internalAutomaticUserDeletionEnabled: boolean;
		internalAutomaticUserDeletionDaysAfterDate: number;
		isPostHogEnabled: boolean;
		postHogApiKey: string;
	}
	export interface IFooterMenuViewModel
	{
		isManualVisible: boolean;
		manualLabel: string;
		isAccessibilityVisible: boolean;
		accessibilityLabel: string;
		isTermsOfUseVisible: boolean;
		termsOfUseLabel: string;
		isPrivacyVisible: boolean;
		privacyLabel: string;
		isImprintVisible: boolean;
		imprintLabel: string;
		isYourFeedbackVisible: boolean;
		isImprintOnLoginPageVisible: boolean;
		isYourFeedbackOnLoginPageVisible: boolean;
	}
	export interface ISpaceSettingsDto
	{
		isTeamVisible: boolean;
		isMilestoneVisible: boolean;
		isAccessSelectionEnabled: boolean;
		areTagsEnabled: boolean;
		isStateVisible: boolean;
		isIdeaTypeVisible: boolean;
		isImageVisible: boolean;
		isIdeaCategoryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		isIdeaCountryVisible: boolean;
		isClosingDateVisible: boolean;
		isContentBoxVisible: boolean;
		criterion1Name: string;
		criterion2Name: string;
		criterion3Name: string;
		contentBoxTitle: string;
		contentBoxContent: string;
		spaceId: number;
		areResponsibilitiesVisible: boolean;
		isCurrentlyResponsibleVisible: boolean;
		isUserGroupSelectionRequired: boolean;
		isEveryoneAllowedToManageUserGroups: boolean;
	}
	export interface ICultureSettingsDto
	{
		visibleCultures: CwxBackend.ICultureDto[];
		currentCultureCode: string;
	}
	export interface IConfigurationDto
	{
		isUserDirectorySearchEnabled: boolean;
		userMinSearchTextLength: number;
	}
	export interface ICultureDto
	{
		order: number;
		isDefault: boolean;
		isVisible: boolean;
		cultureCode: string;
		isRightToLeft: boolean;
		translationType: CwxBackend.TranslationType;
		cultureNameInCurrentCulture: string;
		cultureNameInItsOwnCulture: string;
	}
	export enum TranslationType {
		Formal = 0,
		Informal = 1
	}
	export enum TabType {
		Custom = 1,
		Comments = 2,
		Description = 3,
		Tasks = 5,
		Workflow = 8,
		UtilitiesAndRewards = 9,
		ChildIdeas = 10,
		History = 12,
		Financial = 13
	}
	export interface IValidationProblemDetails
	{
		errors: { [key:string]: string[] };
	}
	export interface IOperationResultBasic
	{
		success: boolean;
		message: string;
	}
	export interface ICulture
	{
		order: number;
		isDefault: boolean;
		isVisible: boolean;
		cultureCode: string;
		isRightToLeft: boolean;
		translationType: CwxBackend.TranslationType;
	}
	export interface ISelectItemDto
	{
		selectId: string;
		selectText: string;
		selectExtendedDescription: string;
	}
	export interface IWelcomePageDto
	{
		content: string;
		title: string;
		teasers: CwxBackend.ITeaserModel[];
	}
	export interface IPageDto
	{
		id: number;
		title: string;
		content: string;
		supportEmail: string;
	}
	export enum ECommonErrorPageType {
		IdeaDoesNotExist = 0,
		SamlRequestInvalid = 1,
		ModuleNotAvailable = 2,
		TaskTypeDoesNotExist = 3,
		TaskDoesNotExist = 4,
		DuplicatedUserName = 5,
		DuplicatedEmail = 6
	}
	export interface ITeaserModel
	{
		teaserID: number;
		title: string;
		description: string;
		url: string;
		imageId: number;
		buttonText: string;
		styleType: CwxBackend.ETeaserStyle;
		isBackgroundShown: boolean;
		order: number;
		isVisible: boolean;
	}
	export enum ETeaserStyle {
		Light = 1,
		Dark = 2
	}
	export interface IIdeaTabDto
	{
		id: any;
		title: string;
		tabLinkHref: string;
		tabType: CwxBackend.TabType;
	}
	export interface IStandardTabContentDto
	{
		id: any;
		ideaId: number;
		tabContainerId: string;
		updateTargetId: string;
		title: string;
		lastEdited: string;
		formEntry: CwxBackend.IFormEntryViewModel;
		isEditMode: boolean;
		isEditable: boolean;
		lockStatus: string;
		isLinkingItemsEnabled: boolean;
		isGalleryModeEnabled: boolean;
		hasLinkingRights: boolean;
	}
	export interface IHistoryEventsViewModel
	{
		ideaId: number;
		tabId: any;
		showTime: boolean;
		allEventsCount: number;
		historyEvents: CwxBackend.IBaseHistoryEventViewModel[];
	}
	export enum HistoryEventType {
		StateChanged = 1,
		MilestoneChanged = 2,
		FormFieldChanged = 4,
		DueDateExtension = 5,
		IdeaRoleChanged = 6,
		IdeaUserRoleChanged = 7,
		BaseDataChanged = 8,
		RewardShareChanged = 9,
		DocumentSent = 10,
		BadgeReceived = 11,
		TaskReturnedToAssignee = 12,
		WorkflowPropertyChanged = 13,
		IdeaSubmitted = 14,
		IdeaDraftSaved = 15,
		DocumentGenerated = 16,
		MeetingCreated = 17
	}
	export interface IBaseHistoryEventViewModel
	{
		user: any;
		eventDate: string;
		eventTypeDisplayName: string;
		ideaId: number;
		isDraft: boolean;
	}
	export interface IBaseDataChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		title: string;
		categoryLabel: string;
		categoryName: string;
		ideaTypeLabel: string;
		ideaTypeName: string;
		accessLevelName: string;
		regionsLabel: string;
		regionsNames: string[];
	}
	export interface IDocumentGeneratedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		file: CwxBackend.ISelectedFileViewModel;
	}
	export interface IDocumentSentHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		file: CwxBackend.ISelectedFileViewModel;
	}
	export interface IDraftSavedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
	}
	export interface IDueDateExtensionHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		newDueDate: string;
		comment: string;
	}
	export interface IFormFieldChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		formName: string;
		formFieldValues: CwxBackend.IFormFieldValueViewModel[];
	}
	export interface IIdeaRoleChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		roleDisplayName: string;
		userRef: any;
	}
	export interface IIdeaSubmittedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
	}
	export interface IIdeaUserRoleChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		roleDisplayName: string;
		userRef: any;
		roleOwnerRef: any;
	}
	export interface IMeetingCreatedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		startTime: string;
		meetingUrl: string;
		subject: string;
	}
	export interface IMilestoneChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		oldMilestone: string;
		newMilestone: string;
		milestoneChangeDescription: string;
	}
	export interface IRewardShareChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		changedRewardSharesByUser: any[];
	}
	export interface IChangedRewardHistoryEventDto
	{
		rewardShare: number;
		userViewModel: CwxBackend.IUserDto;
	}
	export interface IStateChangedHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		oldState: string;
		newState: string;
		dueDate: string;
		closingDate: string;
		description: string;
	}
	export interface ITaskReturnedToAssigneeHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		taskId: any;
		taskType: string;
		newDueDate: string;
		comment: string;
	}
	export interface IWorkflowPropertyHistoryEventViewModel extends CwxBackend.IBaseHistoryEventViewModel
	{
		propertyName: string;
		propertyValue: string;
		unit: string;
	}
	export interface IWorkflowTabDto
	{
		tabId: any;
		ideaId: number;
		workflowId: any;
		states: CwxBackend.IWorkflowStateDto[];
		currentState: CwxBackend.IWorkflowStateDto;
		visibleState: CwxBackend.IWorkflowStateDto;
		visibleForm: CwxBackend.IWorkflowTabContentDto;
	}
	export interface IWorkflowTabContentDto
	{
		currentStateName: string;
		userCanSwitchStates: boolean;
		userCanSeeGearIcon: boolean;
		userCanEdit: boolean;
		userCanView: boolean;
		isInactivated: boolean;
		isDueDateShown: boolean;
		isExtendDeadlineBtnShown: boolean;
		dueDate: string;
		draftDate: string;
		draftedByUserName: string;
		isDraft: boolean;
		form: CwxBackend.IStandardTabContentDto;
	}
	export interface IUpdateWorkflowTabContentCommand
	{
		tabId: any;
		currentStateName: string;
		ideaId: number;
		formEntry: CwxBackend.IFormEntryDto;
		isDraft: boolean;
	}
	export interface IFormEntryViewModel
	{
		id: any;
		formFieldValues: CwxBackend.IFormFieldValueViewModel[];
		formDefinition: CwxBackend.IFormViewModel;
		formId: number;
		renderedInCultureCode: string;
		isSubmissionFormView: boolean;
	}
	export interface IFormViewModel
	{
		id: number;
		title: string;
		slug: string;
		dateAdded: string;
		fields: CwxBackend.IFormFieldViewModel[];
		status: number;
		tabOrder: number;
		entries: CwxBackend.IFormFieldValueViewModel[];
		groupedEntries: CwxBackend.IFormFieldValueViewModel[][];
		isEnabled: boolean;
		cultureCodeOfForm: string;
		isSingleChoiceFilterOptionVisible: boolean;
		usage: any;
		aiAssistantViewModels: CwxBackend.IAIAssistantViewModel[];
		ideaRoles: any[];
		peoplePickerRoles: CwxBackend.ICwxSelectListItem[];
		isEligibilityTaskForm: boolean;
		spaceId: number;
	}
	export interface IFormFieldViewModel
	{
		id: number;
		name: string;
		label: string;
		labelLocaleViewModel: CwxBackendOnboarding.ICustomLocaleViewModel;
		fieldType: CwxBackend.FieldType;
		isRequired: boolean;
		isObsolete: boolean;
		isFilterable: boolean;
		hoverText: string;
		subLabel: string;
		size: string;
		columns: number;
		rows: number;
		validation: string;
		order: number;
		dateAdded: string;
		helpText: string;
		helpTextLocaleViewModel: CwxBackendOnboarding.ICustomLocaleViewModel;
		domId: number;
		minDate: string;
		maxDate: string;
		isMinDateToday: boolean;
		isMaxDateToday: boolean;
		mode: number;
		errors: string;
		inputValue: string;
		min: number;
		max: number;
		unit: string;
		templateId: string;
		selectOptions: CwxBackend.ICwxSelectListItem[];
		choices: CwxBackend.IChoiceItem[];
		columnItems: CwxBackend.ICwxSelectListItem[];
		rowItems: CwxBackend.ICwxSelectListItem[];
		itemsDictionaryId: any;
		itemsDictionary2Id: any;
		idForFormula: string;
		formula: string;
		isVisibleForNormalUser: CwxBackend.EFormBuilderVisability;
		thisConditionId: string;
		conditionId: string;
		conditionChoiceId: string;
		askQuestionButtonType: number;
		peoplePickerButtonType: number;
		peoplePickerRoles: string[];
		isPeoplePickerRegionFilterEnabled: boolean;
		formBuilderDropdownMode: number;
		peoplePickerModel: CwxBackend.IPeoplePickerViewModel;
		isReadOnly: boolean;
		mappingMode: number;
		peoplePickerAssignType: CwxBackend.PeoplePickerAssignType;
		currenciesCodes: CwxBackend.ICwxSelectListItem[];
		aiAssistantViewModel: CwxBackend.IAIAssistantViewModel;
		contentType: CwxBackend.ContentType;
	}
	export enum PeoplePickerButtonType {
		ShowSelectUserButton = 0,
		ShowAssigneMyselfButton = 1,
		BothButtons = 2
	}
	export enum PeoplePickerAssignType {
		SingleUser = 0,
		MultiUser = 1
	}
	export interface IFormFieldValueViewModel
	{
		id: number;
		name: string;
		fieldId: number;
		entryId: string;
		validationProperties: { [key:string]: any };
		value: string;
		displayValue: string;
		rawValue: string;
		unit: string;
		templateId: string;
		targetSpaceNameId: string;
		dateAdded: string;
		userId: any;
		fieldType: CwxBackend.FieldType;
		isReadOnly: boolean;
		isRequired: boolean;
		isFilterable: boolean;
		isDirty: boolean;
		fieldLabel: string;
		fieldOrder: number;
		additionalParameters: { [key:string]: any };
		selectOptions: CwxBackend.ICwxSelectListItem[];
		currencySymbols: CwxBackend.ICwxSelectListItem[];
		choices: CwxBackend.IChoiceItem[];
		tableValues: CwxBackend.IFormFieldTableValueViewModel;
		taskResults: CwxBackend.IFormFieldTaskResultsViewModel;
		selectedFilesValues: CwxBackend.IFormFieldFilePickerValueViewModel;
		idForFormula: string;
		formula: string;
		formulaCalculationHasError: boolean;
		calculationErrorMessage: string;
		isVisibleForNormalUser: CwxBackend.EFormBuilderVisability;
		thisConditionId: string;
		conditionId: string;
		conditionChoiceId: string;
		askQuestionButtonType: number;
		formBuilderDropdownMode: number;
		peoplePickerModel: CwxBackend.IPeoplePickerViewModel;
		pickedPersonModels: CwxBackend.IUserViewModel[];
		mappingMode: number;
		contentType: CwxBackend.ContentType;
		moneyViewModel: CwxBackend.IMoneyViewModel;
		dateTimeOffsetValue: string;
		aiAssistantViewModel: CwxBackend.IAIAssistantViewModel;
		decimalValue: number;
	}
	export interface IPeoplePickerViewModel
	{
		listOfPickedPersons: CwxBackend.IUserViewModel[];
		isGraphSearch: boolean;
		maxUserToPick: number;
		label: string;
		showLabel: boolean;
		showAssigneMyselfButton: boolean;
		showSelectUserButton: boolean;
		isUserSelectionEnabled: boolean;
	}
	export interface IFormFieldFilePickerValueViewModel
	{
		selectedFiles: CwxBackend.ISelectedFileViewModel[];
		numberOfSelectedFiles: number;
	}
	export interface IFormFieldTableValueViewModel
	{
		values: number[][];
		columnIds: any[];
		rowIds: any[];
		columnNames: string[];
		rowNames: string[];
		unit: string;
	}
	export interface IFormFieldTaskResultsViewModel
	{
		answers: any[];
		columnIds: any[];
		rowIds: any[];
		rows: string[];
		columns: string[];
		unit: string;
	}
	export interface ISelectedFileViewModel
	{
		orginalFileName: string;
		filePath: string;
		posterPath: string;
		thumbnailPath: string;
		fileMimeType: string;
		fileSize: number;
		fileExtension: string;
		fileCreateDate: string;
		fileCultureCode: string;
		uploadingUserId: string;
		fileId: number;
		fileIdentifier: any;
		isVideoFile: boolean;
		fileSource: string;
		filePreviewPath: string;
		fileIconPath: string;
		thumbnailFileId: number;
	}
	export interface IMoneyViewModel
	{
		amount: number;
		currencyId: any;
		currencyIdValue: number;
		isComputed: boolean;
	}
	export interface IMoneyDto
	{
		amount: number;
		currencyIdValue: number;
	}
	export interface IChoiceItem
	{
		id: string;
		choiceId: string;
		numericValue: number;
	}
	export enum FieldType {
		TEXTBOX = 0,
		TEXTAREA = 1,
		CHECKBOXGROUP = 2,
		PASSWORD = 3,
		FORM_CHECKBOX = 4,
		H1 = 5,
		HEADER = 6,
		DROPDOWNLIST = 7,
		SINGLECHOICE = 8,
		FULLNAME = 9,
		EMAIL = 10,
		ADDRESS = 11,
		PHONE = 12,
		FORM_DATEPICKER = 13,
		FILEPICKER = 14,
		PEOPLEPICKER = 15,
		FORM_SLIDER = 16,
		NUMBERBOX = 17,
		MONEY = 18,
		FORM_TABLE = 19,
		FORM_TASKRESULTS = 20,
		COMMENT = 21,
		COMPUTEDBOX = 22,
		GENERATEDOCUMENTBTN = 24,
		GENERATEREWARDBTN = 25,
		BOOLEAN = 26,
		ASKQUESTION = 27,
		TEXTAREA_FULLWIDTH = 28,
		HAIRLINE = 29,
		READONLY = 30,
		READWRITE = 31,
		SIMILARIDEASBTN = 32,
		COPYENTRYBTN = 33,
		LIVEREWARD = 34,
		DATETIMEPICKER = 35,
		CREATETASK = 36
	}
	export enum ContentType {
		None = 0,
		Symbol = 1,
		Number = 2,
		Logical = 3,
		Timestamp = 4,
		Text = 5,
		Money = 6,
		Choice = 7,
		File = 8,
		User = 9,
		Table = 10
	}
	export class FormsConstants
	{
		public static SYSTEM_PREFIX: string = `System.`;
		public static MaximumFileSize: number = 209715200;
		public static MaximumImageSizeInBytes: number = 10485760;
	}
	export enum AskQuestionButtonType {
		AskQuestionToAuthor = 0,
		AskQuestionToOtherUser = 1,
		BothButtons = 2
	}
	export interface ISimilarIdeaDto
	{
		ideaId: number;
		title: string;
		trimmedDescription: string;
		imageUrl: string;
		localizedSpaceName: string;
		imageFileId: number;
	}
	export interface ILiveRewardCalculationResponse
	{
		displayValue: string;
		amount: string;
		currencyId: number;
		symbol: string;
		formattedAmount: string;
	}
	export interface IFormEntryDto
	{
		id: any;
		formId: number;
		renderedInCultureCode: string;
		formFieldValues: CwxBackend.IFormFieldValueDto[];
	}
	export interface IFormFieldValueDto
	{
		id: number;
		name: string;
		value?: string;
		rawValue: string;
		fieldId: number;
		fieldOrder: number;
		entryId: string;
		fieldType: CwxBackend.FieldType;
		formula: string;
		idForFormula: string;
		choices: CwxBackend.IChoiceItem[];
		selectOptions: CwxBackend.ICwxSelectListItem[];
		tableValues: CwxBackend.IFormFieldTableValueViewModel;
		moneyValue: CwxBackend.IMoneyDto;
		listOfPickedPersons: CwxBackend.IUserDto[];
		contentType: CwxBackend.ContentType;
	}
	export interface IFileValueObject
	{
		fileName: string;
		savePath: string;
		saveName: string;
		extension: string;
	}
	export interface IAddressViewModel
	{
		id: number;
		address1: string;
		address2: string;
		city: string;
		state: string;
		zipCode: string;
		country: string;
		longitude: string;
		latitude: string;
	}
	export interface ITabContentViewModel
	{
		id: any;
		ideaId: number;
		tabContainerId: string;
		updateTargetId: string;
		title: string;
		lastEdited: string;
		isEditable: boolean;
		isEditMode: boolean;
		isDraft: boolean;
		isEditWarningEnabled: boolean;
		displayAction: any;
		editAction: any;
		formEntry: CwxBackend.IFormEntryViewModel;
		lockStatus: string;
		targetController: string;
		areCommentsTeamsButtonVisible: boolean;
		tabType: CwxBackend.TabType;
		isStickyTab: string;
		isLinkingItemsEnabled: boolean;
		isGalleryModeEnabled: boolean;
		hasLinkingRights: boolean;
	}
	export interface ITabContentRequest
	{
		tabId: any;
		ideaId: number;
		isEditMode: boolean;
	}
	export interface IUpdateStandardTabContentCommand
	{
		id: any;
		title: string;
		ideaId: number;
		formEntry: CwxBackend.IFormEntryDto;
	}
	export interface IGetTaskFormRequest
	{
		ideaId: number;
		ideaIdsForBatchTaskCreate: string;
		isGroupedTask: boolean;
		forceAssignToAuthor: boolean;
		forceAssignToOtherUser: boolean;
		forceContactTask: boolean;
	}
	export interface ITaskCreateEditCommand
	{
		id: any;
		taskExists: boolean;
		templateId: any;
		startDate: string;
		dueDate: string;
		description: string;
		listOfPickedPersons: CwxBackend.IUserDto[];
		assignToLinkedObjectAuthor: boolean;
		ideaId: number;
		ideaIdsForBatchTaskCreate: number[];
		ownerId: string;
		taskGroupId: any;
		isGroupedTask: boolean;
		taskAssignmentMode: CwxBackend.TaskAssignmentMode;
	}
	export interface ITaskCreateEditDto
	{
		id: any;
		taskExists: boolean;
		templateId: any;
		startDate: string;
		dueDate: string;
		description: string;
		peoplePickerModel: CwxBackend.IPeoplePickerDto;
		assignToLinkedObjectAuthor: boolean;
		checkStateId: number;
		ideaId: number;
		ideaTitle: string;
		ideaUrl: string;
		ideaAuthorId: string;
		ideaAuthorEmail: string;
		ideaIdsForBatchTaskCreate: number[];
		ownerId: string;
		taskGroupId: any;
		isGroupedTask: boolean;
		assignToAuthorVisible: boolean;
		taskTypePickerVisible: boolean;
		availableTaskTypes: CwxBackend.ICwxSelectListItem[];
	}
	export interface ITaskCreateEditResultDto
	{
		isUserReplaced: boolean;
		toastHeader: string;
		toastContent: string[];
	}
	export interface IGetTasksTabRequest
	{
		ideaId: number;
		isEditMode: boolean;
	}
	export interface ITasksTabDto
	{
		percentageOfCompletedTasks: number;
		isEditMode: boolean;
		canCreateTasks: boolean;
		tasks: CwxBackend.ITaskDto[];
	}
	export interface ITaskDto
	{
		id: any;
		dueDate: string;
		dueDateColor: string;
		startDate: string;
		templateName: string;
		usersAssignedTo: CwxBackend.IUserDto[];
		owner: CwxBackend.IUserDto;
		stateName: string;
		lastReminderSendDate: string;
		completedDate: string;
		isEditAllowed: boolean;
	}
	export interface ITaskTemplateDto
	{
		description: string;
		defaultDueDateNrOfDays: number;
	}
	export enum TaskAssignmentMode {
		Individual = 0,
		Group = 1
	}
	export interface IMyTasksDto
	{
		areMyEmployeesIdeasEnabled: boolean;
		pendingWorkflowTasksCount: number;
		pendingStandardTasksCount: number;
		pendingEvaluationsCount: number;
		isTodoEnabled: boolean;
	}
	export interface IMyWorkflowTasksDto
	{
		isTodoTasksEnabled: boolean;
		listItems: CwxBackend.IMyWorkflowTasksListItemDto[];
	}
	export interface IMyWorkflowTasksListItemDto
	{
		id: number;
		dueDate: string;
		dueDateColor: string;
		workflowTaskId: any;
		workflowTaskName: string;
		workflowTaskUrl: string;
		ideaId: number;
		ideaTitle: string;
		ideaUrl: string;
		stateName: string;
		stateId: string;
		spaceDisplayName: string;
		lastReminder: string;
		completed: string;
		stateOrder: number;
		isDisplayed: boolean;
		isInTodo: boolean;
		canBeCopiedToTodo: boolean;
	}
	export interface IMyStandardTasksDto
	{
		isTodoTasksEnabled: boolean;
		listItems: CwxBackend.IMyStandardTasksListItemDto[];
	}
	export interface IMyStandardTasksListItemDto
	{
		id: string;
		dueDate: string;
		dueDateColor: string;
		startDate: string;
		templateName: string;
		templateId: any;
		usersAssignedTo: CwxBackend.IUserDto[];
		assignedUserNames: string;
		owner: CwxBackend.IUserDto;
		stateId: any;
		stateName: string;
		stateOrder: number;
		spaceDisplayName: string;
		lastReminderSendDate: string;
		completedDate: string;
		ideaId: number;
		ideaTitle: string;
		ideaUrl: string;
		isEndState: boolean;
		isGroupedTask: boolean;
		isHighlighted: boolean;
		isOwnerDisplayed: boolean;
		isInTodo: boolean;
		isCompleted: boolean;
		isAutomatic: boolean;
		isEvaluation: boolean;
		isEditAllowed: boolean;
	}
	export interface IMyEvaluationsDto
	{
		myScorecards: CwxBackend.IMyScorecardListItemDto[];
	}
	export interface IMyScorecardListItemDto
	{
		id: number;
		title: string;
		completedTasks: string;
		startDate: string;
		dueDate: string;
		isDisplayed: boolean;
	}
	export interface IMyEmployeeItemListItemDto
	{
		ideaId: number;
		title: string;
		submittedDate: string;
		spaceDisplayName: string;
		spaceId: number;
		milestoneDisplayName: string;
		authors: string;
		closingDate: string;
		state: string;
		stateColor: string;
	}
	export interface IMyRewardGridItemDto
	{
		id: number;
		ideaTitle: string;
		link: string;
		rewardClosingDate: string;
		utilityTypeName: string;
		ideaId: number;
		lastExportDate: string;
		originalRewardValue: number;
		originalRewardCurrencyLabel: string;
	}
	export interface IUtilityAndRewardsTabDto
	{
		utilitiesGrid: CwxBackend.IUtilityGridDto;
		rewardsGrid: CwxBackend.IRewardsGridDto;
		rewardDocumentGrid: CwxBackend.IRewardDocumentGridDto;
		rewardDocumentsVisible: boolean;
	}
	export interface IUtilityGridDto
	{
		utilities: CwxBackend.IUtilityGridItemDto[];
		totalUtilitiesFormatted: string;
		totalGrossRewardFormatted: string;
		totalBaseRewardFormatted: string;
	}
	export interface IUtilityGridItemDto
	{
		id: number;
		utilityType: number;
		utilityTypeName: string;
		valueAmount: number;
		valueFormattedValue: string;
		baseRewardAmount: number;
		baseRewardFormattedValue: string;
		grossRewardAmount: number;
		grossRewardFormattedValue: string;
		baseRewardPercent: number;
		rewardReductionPercent: number;
		isEditable: boolean;
		comment: string;
		dateAdded: string;
		dateEdited: string;
		dateClosed: string;
	}
	export interface IRewardsGridDto
	{
		rewards: CwxBackend.IRewardGridItemDto[];
		departmentLabel: string;
		showCountryFactorColumn: boolean;
		showUserDataFields: boolean;
	}
	export interface IRewardGridItemDto
	{
		id: number;
		userId: string;
		userDisplayName: string;
		userEmail: string;
		userEmailAnonymized: string;
		onlyUserCanSeeSelf: boolean;
		staffNumber: string;
		departmentShortName: string;
		company: string;
		dateClosed: string;
		dateAdded: string;
		lineManagerId: string;
		lineManagerDisplayName: string;
		lineManagerDisplayNameAnonymized: string;
		rewardEligibility: number;
		rewardShare: number;
		rewardShareFormatted: string;
		baseReward: number;
		baseRewardCurrencyId: number;
		baseRewardCurrencyCode: string;
		baseRewardCurrencySymbol: string;
		rewardValue: number;
		rewardCurrencyId: string;
		rewardCurrencySymbol: string;
		isEditable: boolean;
		utilityId: number;
		userStateDisplayName: string;
		countryFactor: number;
		valueAmount: number;
		valueFormatted: string;
		baseValueAmount: number;
		baseValueFormatted: string;
	}
	export interface IRewardDocumentGridDto
	{
		rewardDocuments: CwxBackend.IRewardDocumentGridItemDto[];
		availablePaymentOffices: CwxBackend.ISelectItemDto[];
		availableTemplates: CwxBackend.ISelectItemDto[];
	}
	export interface IRewardDocumentGridItemDto
	{
		id: number;
		userDisplayName: string;
		onlyUserCanSeeSelf: boolean;
		rewardDisplay: string;
		paymentOffice: CwxBackend.ISelectItemDto;
		rewardDocumentFileIdentifier: any;
		rewardDocumentFileName: string;
		approved: boolean;
		dateAdded: string;
		dateClosed: string;
		lastSent: string;
		template: CwxBackend.ISelectItemDto;
	}
	export interface IUpdateRewardDocumentPaymentOfficeCommand
	{
		rewardDocumentId: number;
		paymentOfficeId: number;
	}
	export interface IUpdateRewardDocumentTemplateCommand
	{
		rewardDocumentId: number;
		templateId: number;
	}
	export interface IUpdateRewardEligibilitiesCommand
	{
		rewards: CwxBackend.IUpdateRewardEligibilityCommand[];
	}
	export interface IUpdateRewardEligibilityCommand
	{
		rewardId: number;
		rewardEligibility: number;
	}
	export interface ISpaceMenuItemDto
	{
		id: number;
		spaceId: CwxBackend.ISpaceId;
		text?: string;
		tooltip: string;
		icon?: string;
		isAdminOnly: boolean;
		order: number;
		url: string;
		type: CwxBackend.SpaceSidebarType;
		menuItemType?: CwxBackend.SpaceSidebarFixedMenuItemType;
		accessLevel: CwxBackend.SpaceSidebarAccessLevel;
		subItems: CwxBackend.ISpaceMenuItemDto[];
	}
	export interface IMegaMenuViewModel
	{
		menuItemViewModels: any[];
		topSubmitButtonVisible: boolean;
		topSubmitButtonUrl: string;
		topSubmitButtonText: string;
		userNavigationProfileVisible: boolean;
		userNavigationIdeasVisible: boolean;
		myIdeaItemsText: string;
		userNavigationTasksVisible: boolean;
		userNavigationClosedCompetitionsVisible: boolean;
		userNavigationSettingsVisible: boolean;
		accountSettingsNavigation: any;
		isUserRegistration: boolean;
		topSearchBoxVisible: boolean;
	}
	export enum SpaceSidebarAccessLevel {
		Public = "Public",
		Evaluation = "Evaluation",
		Visualization = "Visualization",
		DataCenter = "DataCenter",
		Reporting = "Reporting",
		AdminHome = "AdminHome",
		Submit = "Submit",
		AdminSubmit = "AdminSubmit"
	}
	export interface IIdeaDetailsDto
	{
		ideaId: number;
		spaceId: number;
		spaceName: string;
		title: string;
		tabs: CwxBackend.IIdeaTabDto[];
		availableStates: CwxBackend.ICwxSelectListItem[];
		isVotingActive: boolean;
		isInvisibleState: boolean;
		thumbnailPath: string;
		originalImagePath: string;
		imageId: number;
		canUserEditTags: boolean;
		state: CwxBackend.IIdeaWorkflowStateDto;
		isInMaintenanceMode: boolean;
		shouldDisplayMaintenanceMode: boolean;
		isCampaignMode: boolean;
		isManagementRightsAvailable: boolean;
	}
	export interface IWorkflowTabRequest
	{
		tabId: any;
		ideaId: number;
		stateName: string;
		isEditMode: boolean;
	}
	export interface IIdeaSupportBoxDto
	{
		id: number;
		isCurrentlyFollowed: boolean;
		followerCount: number;
		formContainerId: string;
		isIdeaLiked: boolean;
		ideaLikesCount: number;
		isIdeaLikingActive: boolean;
		isIdeaFollowingActive: boolean;
		isIdeaSharingActive: boolean;
		isCalendarButtonVisible: boolean;
		isTeamsButtonVisibleWithDeepLinking: boolean;
		canUserEditIdea: boolean;
	}
	export interface ICopyIdeaRequest
	{
		ideaId: number;
		targetSpaceNameId: string;
	}
	export interface ICopyIdeaDetailsDto
	{
		ideaId: number;
		targetSpaceId: number;
		spacesToSelect: CwxBackend.ICwxSelectListItem[];
		selectedSpaceId: number;
	}
	export interface IIdeaInfoForSidebarBoxDto
	{
		id: number;
		visitCount: number;
		commentCount: number;
		followersCount: number;
		ideaLikesCount: number;
		areManagementRightsAvailable: boolean;
		dateCreated: string;
		currentClosingDate: string;
		parentIdea: CwxBackend.IParentIdeaLinkViewModel;
		originalIdea: CwxBackend.IOriginalIdeaLinkViewModel;
		milestone: CwxBackend.ICustomDictionaryItemViewModel;
		type: CwxBackend.ICustomDictionaryItemViewModel;
		category: CwxBackend.ICustomDictionaryItemViewModel;
		accessLevel: CwxBackend.ICustomDictionaryItemViewModel;
		divisionId: number;
		department: string;
		divisionName: string;
		author: CwxBackend.IUserDto;
		coAuthors: CwxBackend.IUserDto[];
		isAuthorSubmitter: boolean;
		submitter: CwxBackend.IUserDto;
		shouldDisplayDivision: boolean;
		shouldDisplayDepartment: boolean;
		competitionAnswerLink: any;
		flyoutViewModel: any;
		ideaAuthorLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		coAuthorsLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		submitterLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		ideaTypeLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		categoryLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		departmentLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		divisionLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		regionLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		accessLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		milestoneSentensesCaseLabel: string;
		countryLabel: string;
		countries: CwxBackend.ICwxSelectListItem[];
		countryName: string;
		regions: CwxBackend.IIdeaRegionDto[];
		companyLabel: string;
		companies: CwxBackend.ICwxSelectListItem[];
		dataSource: string;
		categoryName: string;
		typeName: string;
		accessLevelName: string;
		areEditingRightsAvailable: boolean;
		isCommentsTabVisible: boolean;
		state: string;
		stateColor: string;
		currentStateId: number;
		currentDepartmentId: number;
		availableStates: CwxBackend.ICwxSelectListItem[];
		isCurrentlyFollowed: boolean;
		isIdeaFollowingActive: boolean;
		isIdeaLikingActive: boolean;
	}
	export interface IIdeaLinkedIdeaDto
	{
		ideaId: number;
		title: string;
		imageFileId: number;
		category: string;
	}
	export interface IIdeaMaintenanceModeDto
	{
		ideaId: number;
		notificationsEnabled: boolean;
	}
	export interface ISetIdeaMaintenanceModeCommand
	{
		ideaId: number;
		setNotificationsEnabled: boolean;
		triggerNotifications: boolean;
	}
	export interface ISetIdeaVotingStateCommand
	{
		ideaId: number;
		votingActive: boolean;
	}
	export interface IIdeaVotingStateDto
	{
		ideaId: number;
		votingActive: boolean;
	}
	export interface IIdeaDetailsTopViewModel
	{
		isReadOnlyMode: boolean;
		id: number;
		spaceId: number;
		spaceName: string;
		title: string;
		description: string;
		imageId: number;
		visitCount: number;
		commentCount: number;
		areManagementRightsAvailable: boolean;
		dateCreated: string;
		currentClosingDate: string;
		parentIdea: CwxBackend.IParentIdeaLinkViewModel;
		originalIdea: CwxBackend.IOriginalIdeaLinkViewModel;
		milestone: CwxBackend.ICustomDictionaryItemViewModel;
		type: CwxBackend.ICustomDictionaryItemViewModel;
		category: CwxBackend.ICustomDictionaryItemViewModel;
		accessLevel: CwxBackend.ICustomDictionaryItemViewModel;
		department: string;
		divisionName: string;
		author: CwxBackend.IUserViewModel;
		coAuthors: CwxBackend.IUserViewModel[];
		isAuthorSubmitter: boolean;
		submitter: CwxBackend.IUserViewModel;
		spaceSettings: CwxBackend.ISpaceSettingsViewModel;
		shouldDisplayDivision: boolean;
		shouldDisplayDepartment: boolean;
		competitionAnswerLink: any;
		flyoutViewModel: any;
		ideaAuthorLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		coAuthorsLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		submitterLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		ideaTypeLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		categoryLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		departmentLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		divisionLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		regionLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		accessLabelLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		milestoneSentensesCaseLabel: string;
		countryLabel: string;
		countryName: string;
		countries: CwxBackend.ICwxSelectListItem[];
		regions: string[];
		dataSource: string;
		companyLabel: string;
		companies: CwxBackend.ICwxSelectListItem[];
		categoryName: string;
		typeName: string;
		accessLevelName: string;
		isInInvisibleState: boolean;
		isInMaintenanceMode: boolean;
		shouldDisplayMaintenanceMode: boolean;
		areEditingRightsAvailable: boolean;
		isCommentsTabVisible: boolean;
		state: string;
		stateColor: string;
		currentStateId: number;
		availableStates: CwxBackend.ICwxSelectListItem[];
	}
	export interface IParentIdeaLinkViewModel
	{
		ideaId: number;
		ideaName: string;
		topicLabel: string;
	}
	export interface IOriginalIdeaLinkViewModel
	{
		ideaId: number;
		ideaName: string;
		topicLabel: string;
		originalIdeaDeleted: boolean;
	}
	export interface ICustomDictionaryItemViewModel
	{
		id: any;
		name: string;
		choiceId: string;
		flowOrder: number;
		flags: number;
		hexColor: string;
		numericValue: number;
	}
	export interface IKeyValuePair
	{
		key: string;
		value: string;
	}
	export interface ISpaceSettingsViewModel
	{
		isMilestoneVisible: boolean;
		isStateVisible: boolean;
		isIdeaCategoryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		isIdeaCountryVisible: boolean;
		currentDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		currentDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isIdeaTypeVisible: boolean;
		isImageVisible: boolean;
		showAuthorBox: boolean;
		showRewardSharesForCoAuthors: boolean;
		showLineManagersForCoAuthors: boolean;
		isLineManagerRequired: boolean;
		areCoAuthorsLMRequired: boolean;
		areAuthorsVisible: boolean;
		isPublicSubmissionEnabled: boolean;
		isPublicAuthorEmailVisible: boolean;
		isPublicSubmissionCreateAccountsEnabled: boolean;
		isPublicSubmissionTermsOfUseVisible: boolean;
		areVotingResultsRestricted: boolean;
		isAccessSelectionEnabled: boolean;
		areIdeasNeedingHelpVisible: boolean;
		areMostDiscussedIdeasVisible: boolean;
		areResponsibilitiesVisible: boolean;
		isCurrentlyResponsibleVisible: boolean;
		isSubmitIdeaVisible: boolean;
		areVisualizationsVisible: boolean;
		isContentBoxVisible: boolean;
		isPanoramaModeActive: boolean;
		isLightPanoramaTextActive: boolean;
		isClosingDateVisible: boolean;
		isLinkingItemsEnabled: boolean;
		isGalleryModeEnabled: boolean;
		isExcludedFromLinking: boolean;
		isUserGroupSelectionRequired: boolean;
		isEveryoneAllowedToManageUserGroups: boolean;
		currentlyResponsibleTitle: CwxBackendOnboarding.ICustomLocaleViewModel;
		responsibilitiesTitle: CwxBackendOnboarding.ICustomLocaleViewModel;
		contentBoxTitle: CwxBackendOnboarding.ICustomLocaleViewModel;
		contentBoxContent: CwxBackendOnboarding.ICustomLocaleViewModel;
		isIdeaListTitleCentered: boolean;
		ideaListTitle: CwxBackendOnboarding.ICustomLocaleViewModel;
		ideaListContent: CwxBackendOnboarding.ICustomLocaleViewModel;
		criterion1Name: string;
		criterion2Name: string;
		criterion3Name: string;
		whoCanSeeOverallVotingResults: CwxBackend.ICwxSelectListItem[];
		spaceId: number;
		isSimilarIdeasSearchEnabled: boolean;
		similaritySearchEnabledSpaces: number[];
		areTagsEnabled: boolean;
		isTeamApplicationEnabled: boolean;
		teamApplicationWorkflowStates: number[];
		requirementsWorkflowPropertyNameId: string;
		socialSettingsViewModel: any;
	}
	export interface IIdeaDetailsRoleMember
	{
		user: CwxBackend.IUserDto;
		roleId: number;
		roleDisplayName: string;
		profileLink: string;
		isTeamsButtonVisible: boolean;
		isEmailButtonVisible: boolean;
		badgeCounterTextColor: string;
		badgeCounterBackgroundColor: string;
	}
	export interface IIdeaDetailsRightSidebarUsersDto
	{
		users: CwxBackend.IIdeaDetailsRoleMember[];
		ideaId: number;
		spaceName: string;
		isGamificationEnabled: boolean;
		title: string;
	}
	export interface IChangeIdeaStateRequest
	{
		ideaId: number;
		newStateId: number;
		currentStateId: number;
		spaceId: number;
		stateChangeDescription: string;
	}
	export interface IChangeIdeaCategoryRequest
	{
		ideaId: number;
		categoryId: any;
	}
	export interface ISpaceDetailsDto
	{
		id: number;
		name: string;
		allItemsNameLocale: string;
		type: CwxBackend.SpaceType;
		isSpaceImageExists: boolean;
		isIdeaFollowingActive: boolean;
		isIdeaLikingActive: boolean;
	}
	export interface IChangeIdeaDivisionRequest
	{
		ideaId: number;
		divisionId: number;
	}
	export interface IChangeIdeaDepartmentRequest
	{
		ideaId: number;
		departmentId: number;
	}
	export interface IChangeIdeaTypeRequest
	{
		ideaId: number;
		typeId: any;
	}
	export interface IChangeIdeaRegionRequest
	{
		ideaId: number;
		regionIds: number[];
	}
	export interface IChangeIdeaCompanyRequest
	{
		ideaId: number;
		companyId: number;
	}
	export interface IChangeIdeaCountryRequest
	{
		ideaId: number;
		countryId: number;
	}
	export interface IIdeaVotingDetailsDto
	{
		ideaId: number;
		vote1: number;
		vote2: number;
		vote3: number;
		sumVote1: number;
		sumVote2: number;
		sumVote3: number;
		createDate: string;
		totalVotes: number;
		isVotedByCurrentUser: boolean;
		isUserIdeaAuthor: boolean;
		canCurrentUserSeeOverallRatings: boolean;
	}
	export interface IIdeaVoteCommand
	{
		ideaId: number;
		vote1: number;
		vote2: number;
		vote3: number;
	}
	export interface IChangeIdeaAccessLevelRequest
	{
		ideaId: number;
		accessLevelId: any;
	}
	export interface IIdeaRegionDto
	{
		value: number;
		text: string;
		nameLocaleValue: CwxBackend.ICustomLocaleValueDto;
	}
	export interface IIdeaCreatorViewModel
	{
		title: string;
		subTitleProtection: string;
		imageFileId: number;
		typeId: any;
		originalIdeaId: number;
		categoryId: any;
		categorySpaceLabel: string;
		ideaTypesLabel: string;
		regionIds: number[];
		departmentId: number;
		departmentLabel: string;
		divisionId: number;
		divisionLabel: string;
		accessLevelId: any;
		coAuthorVM: CwxBackend.ICoAuthorViewModel;
		formEntry: CwxBackend.IFormEntryViewModel;
		competitionAnswerId: number;
		isDraft: boolean;
		workflowDefinitionId: number;
		spaceId: number;
		formTitle: string;
		submitterId: string;
		authorId: string;
		auditData: string[];
		ideaTags: CwxBackend.ITagViewModel[];
		isIdeaTypeVisible: boolean;
		isIdeaCategoryVisible: boolean;
		isIdeaRegionVisible: boolean;
		regionLabel: string;
		isIdeaCompanyVisible: boolean;
		companyLabel: string;
		companyId: number;
		companies: CwxBackend.ICwxSelectListItem[];
		isIdeaCountryVisible: boolean;
		countryLabel: string;
		countryId: number;
		countries: CwxBackend.ICwxSelectListItem[];
		currentDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		currentDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isAccessLevelVisible: boolean;
		isAuthorBoxVisible: boolean;
		areAuthorsVisible: boolean;
		isPublicSubmissionEnabled: boolean;
		isPublicAuthorEmailVisible: boolean;
		publicAuthorEmail: string;
		isPublicSubmissionTermsOfUseVisible: boolean;
		publicSubmissionTermsOfUse: string;
		isPublicSubmissionTermsOfUseAccepted: boolean;
		isCancelVisible: boolean;
		anonymousSubmissionAllowed: boolean;
		isIdeaAnonymityEnabled: boolean;
		spaceSettingsViewModel: CwxBackend.ISpaceSettingsViewModel;
		parentIdeaId: number;
		isChildView: boolean;
		spaceType: CwxBackend.SpaceType;
		hasAdminRights: boolean;
		userGroupId?: number;
		linkedIdeas: { [key in CwxBackend.LinkType]: number[] };
		webLinks: CwxBackend.IWebLinkViewModel[];
	}
	export interface IIdeaEditorViewModel extends CwxBackend.IIdeaCreatorViewModel
	{
		ideaId: number;
		isDeleteRequested: boolean;
	}
	export interface IIdeaWorkflowStateDto
	{
		id: number;
		isVisible: boolean;
		color: string;
		imageUrl: string;
	}
	export interface IShareIdeaDto
	{
		emails: string;
		peopleToInvite: CwxBackend.IPeoplePickerDto;
		mailBody: string;
		ideaId: number;
		ideaName: string;
		ideaLink: string;
		invitingUserEmail: string;
		infoMessage: string;
		filledEmailTemplateContent: string;
	}
	export interface IIdeaChildIdeasDto
	{
		parentIdeaId: number;
		targetSpaceId: number;
		ideas: CwxBackend.IIdeaChildIdeaDto[];
	}
	export interface IIdeaChildIdeaDto
	{
		id: number;
		title: string;
		submitted: string;
		milestone: CwxBackend.ICustomDictionaryItemViewModel;
		state: any;
		author: CwxBackend.IUserDto;
		imageUrl: string;
	}
	export interface IIdeaContentBoxDto
	{
		contentBoxTitle: string;
		contentBoxContent: string;
	}
	export interface ISpaceDto
	{
		id: number;
		name: string;
	}
	export interface IMyItemsListDto
	{
		spaces: CwxBackend.ISpaceDto[];
		challenges: CwxBackend.ISpaceDto[];
		areMyEmployeesIdeasEnabled: boolean;
	}
	export interface ISpaceHomeDto
	{
		spaceId: number;
		isSidebarVisible: boolean;
		spaceName: string;
		imageId: number;
		title: string;
		description: string;
		isBackgroundShown: boolean;
		isLinkingItemsEnabled: boolean;
		isAdminSectionVisible: boolean;
		isGalleryModeEnabled: boolean;
		submitButtonText: string;
		isSubmitButtonVisible: boolean;
	}
	export interface IChallengeHomeDto
	{
		spaceId: number;
		isSidebarVisible: boolean;
		spaceName: string;
		imageId: number;
		title: string;
		description: string;
		isBackgroundShown: boolean;
		submitButtonText: string;
		isSubmitButtonVisible: boolean;
		isSubmitAllowed: boolean;
		isAdminSectionVisible: boolean;
		firstAdminUrl: string;
		isGalleryModeEnabled: boolean;
		isLinkingItemsEnabled: boolean;
		availableTabs: CwxBackend.IChallengeHomeTab[];
	}
	export enum SpaceType {
		Standard = "Standard",
		Template = "Template",
		Challenge = "Challenge"
	}
	export interface IUserGroupId extends CwxBackend.IInt32Identifier
	{
	}
	export interface IUserGroupDto
	{
		id: number;
		spaceId: number;
		type: CwxBackend.ICwxSelectListItem;
		name: string;
		owner: string;
		ownerId: string;
		lastEditDate: string;
		usersCount: number;
		isSelected: boolean;
	}
	export interface IUserGroupRequest
	{
		spaceId: number;
		type: CwxBackend.UserGroupType;
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface IUserGroupNameValidationRequest
	{
		spaceId: number;
		userGroupId: number;
		name: string;
	}
	export interface IUserGroupModalDto
	{
		userGroupId: number;
		name: string;
		spaceId: number;
		type: CwxBackend.UserGroupType;
		owner: CwxBackend.IUserDto;
		participants: CwxBackend.IUserDto[];
		errors: string[];
	}
	export interface IDeleteUserGroupCommand
	{
		userGroupId: number;
	}
	export enum UserGroupType {
		SubmissionForm = "SubmissionForm",
		Scorecard = "Scorecard"
	}
	export interface ICreateUserGroupRequest
	{
		name: string;
		spaceId: number;
		type: CwxBackend.UserGroupType;
		owner: CwxBackend.IUserDto;
		participants: CwxBackend.IUserDto[];
	}
	export interface IUpdateUserGroupCommand
	{
		userGroupId: number;
		name: string;
		type: CwxBackend.UserGroupType;
		participants: CwxBackend.IUserDto[];
	}
	export interface IUserGroupPickerResultDto
	{
		userGroups: CwxBackend.IUserGroupDto[];
		hasMore: boolean;
	}
	export interface IIdeaListRequest
	{
		itemsPerPage: number;
		pageNumber: number;
		searchPhrase?: string;
		isMyIdeas?: boolean;
		isFollowedByMe?: boolean;
		isLikedByMe?: boolean;
		sortBy?: CwxBackend.IdeaListSortingType;
		sortDesc?: boolean;
		spaceIds?: string;
		regionIds?: string;
		departmentIds?: string;
		divisionIds?: string;
		categoryIds?: string;
		ideaTypeIds?: string;
		milestoneIds?: string;
		stateIds?: string;
		tagIds?: string;
		singleChoiceIds?: string;
		userGroupsId?: string;
		currentUser?: any;
	}
	export interface IIdeaDto
	{
		ideaId: number;
		spaceId: number;
		title: string;
		imageUrls: { [key:string]: string };
		creationDate: string;
		modifiedDate: string;
		noOfVisits: number;
		noOfComments: number;
		ideaType: string;
		category: string;
		milestone: string;
		milestoneHexColor: string;
		state: string;
		stateHexColor: string;
		spaceName: string;
		regions: string[];
		valueDeterminate: number;
		divisionName: string;
		department: string;
		accessLevel: string;
		votingScore: string;
		ideaLikesCount: number;
		tags: string[];
		titleHighlight: CwxBackend.IHighlightedTextFragmentDto[];
		snippetHighlight: CwxBackend.IHighlightedTextFragmentDto[];
	}
	export interface IHighlightedTextFragmentDto
	{
		value: string;
		isHighlighted: boolean;
	}
	export interface IPagingInfoDto
	{
		totalItemsCount: number;
		pageNumber: number;
		pageCount: number;
	}
	export interface IPagedResultDto<T>
	{
		data: T[];
		paging: CwxBackend.IPagingInfoDto;
	}
	export interface ISpaceIdeasListDto
	{
		spaceId: number;
		spaceDisplayName: string;
		isInvitingActive: boolean;
		isSubmitIdeaVisible: boolean;
		listSettings: CwxBackend.ISpaceIdeasListSettingsDto;
		submitButton: any;
		flyoutViewModel: any;
	}
	export interface ISpaceIdeasListSettingsDto
	{
		isIdeaListTitleCentered: boolean;
		ideaListTitle: string;
		ideaListContent: string;
	}
	export interface IMyItemsRequest
	{
		spaceId?: number;
		spaceType: CwxBackend.SpaceType;
	}
	export interface IMyItemDto
	{
		isDraft: boolean;
		ideaId: number;
		title: string;
		dateCreated: string;
		itemUrl: string;
		spaceType: CwxBackend.SpaceType;
		spaceDisplayName: string;
		spaceId: number;
		state: string;
		stateColor: string;
		milestone: string;
		dateCreatedDatePart: string;
	}
	export interface IIdeaListAllMetadataDto
	{
		listViewModes: CwxBackend.ISelectListEnumItemDto<CwxBackend.IdeaListViewMode>[];
		sortings: CwxBackend.ISelectListEnumItemDto<CwxBackend.IdeaListSortingType>[];
		dataItems: CwxBackend.ISelectListEnumItemDto<CwxBackend.IdeaListDataItemType>[];
		filters: CwxBackend.IIdeaListFilterItemDto[];
	}
	export interface IIdeaListFilterItemDto
	{
		filter: CwxBackend.IIdeaListFilter;
		uiType: CwxBackend.IdeaListFilterUiType;
		selectListItems: CwxBackend.ICwxSelectListItem[];
		selectListItemsWithSpaceIds: CwxBackend.ISelectListItemsWithSpaceIdDto[];
	}
	export interface IIdeaListSettingsDto
	{
		isSearchEnabled: boolean;
		listViewMode: CwxBackend.IdeaListViewMode;
		sortingTypes: CwxBackend.IdeaListSortingType[];
		filterTypes: CwxBackend.IIdeaListFilter[];
	}
	export interface IIdeaListSettingsAllMetadataDto
	{
		allMetadata: CwxBackend.IIdeaListAllMetadataDto;
	}
	export interface IIdeaListSpaceRequestSettingsDto extends CwxBackend.IIdeaListSettingsDto
	{
		isSearchEnabled: boolean;
		listViewMode: CwxBackend.IdeaListViewMode;
		sortingTypes: CwxBackend.IdeaListSortingType[];
		filterTypes: CwxBackend.IIdeaListFilter[];
		spaceSpecificSettings: CwxBackend.IIdeaListSpaceSpecificSettingsDto;
	}
	export interface IIdeaListSpaceResponseSettingsDto extends CwxBackend.IIdeaListSettingsDto, CwxBackend.IIdeaListSettingsAllMetadataDto
	{
		isSearchEnabled: boolean;
		listViewMode: CwxBackend.IdeaListViewMode;
		sortingTypes: CwxBackend.IdeaListSortingType[];
		filterTypes: CwxBackend.IIdeaListFilter[];
		spaceSpecificSettings: CwxBackend.IIdeaListSpaceSpecificSettingsDto;
		allMetadata: CwxBackend.IIdeaListAllMetadataDto;
		ideaListSpaceSettings: CwxBackend.ISpaceIdeasListDto;
	}
	export interface IIdeaListGlobalRequestSettingsDto extends CwxBackend.IIdeaListSettingsDto
	{
		isSearchEnabled: boolean;
		listViewMode: CwxBackend.IdeaListViewMode;
		sortingTypes: CwxBackend.IdeaListSortingType[];
		filterTypes: CwxBackend.IIdeaListFilter[];
	}
	export interface IIdeaListGlobalResponseSettingsDto extends CwxBackend.IIdeaListSettingsDto, CwxBackend.IIdeaListSettingsAllMetadataDto
	{
		isSearchEnabled: boolean;
		listViewMode: CwxBackend.IdeaListViewMode;
		sortingTypes: CwxBackend.IdeaListSortingType[];
		filterTypes: CwxBackend.IIdeaListFilter[];
		allSpaceSpecificSettings: { [key:number]: CwxBackend.IIdeaListSpaceSpecificSettingsDto };
		allMetadata: CwxBackend.IIdeaListAllMetadataDto;
	}
	export interface IIdeaListSpaceSpecificSettingsDto
	{
		dataItemTypes: CwxBackend.IdeaListDataItemType[];
	}
	export interface ISelectListEnumItemDto<TEnumId>
	{
		value: TEnumId;
		text: string;
	}
	export interface ISelectListItemDto
	{
		id: string;
		text: string;
	}
	export interface ISelectListItemsWithSpaceIdDto
	{
		spaceId: number;
		selectListItems: CwxBackend.ICwxSelectListItem[];
	}
	export interface IIdeaListFilter
	{
		type: CwxBackend.IdeaListFilterType;
		formFieldId: number;
		text: string;
		order: number;
	}
	export interface IAwardPagedResult
	{
		pagedResult: CwxBackend.IPagedResultDto<CwxBackend.IAwardIdeaDto>;
		allCategories: CwxBackend.IAwardCategoryDto[];
	}
	export interface IAwardIdeaDto
	{
		ideaId: number;
		spaceId: number;
		title: string;
		imageUrls: { [key:string]: string };
		creationDate: string;
		modifiedDate: string;
		noOfVisits: number;
		noOfComments: number;
		ideaType: string;
		category: string;
		milestone: string;
		milestoneHexColor: string;
		state: string;
		stateHexColor: string;
		spaceName: string;
		regions: string[];
		valueDeterminate: number;
		divisionName: string;
		department: string;
		accessLevel: string;
		votingScore: string;
		ideaLikesCount: number;
		tags: string[];
		titleHighlight: CwxBackend.IHighlightedTextFragmentDto[];
		snippetHighlight: CwxBackend.IHighlightedTextFragmentDto[];
		categoryId: number;
	}
	export interface IAwardCategoryDto
	{
		categoryId: number;
		categoryName: string;
		isDisabled: boolean;
	}
	export interface IAwardVotingSettingsViewModel
	{
		nominateText: string;
		isClosed: boolean;
	}
	export interface IIdeaLikeDto
	{
		ideaId: number;
		isIdeaLikedByUser: boolean;
		ideaLikesCount: number;
	}
	export enum IdeaListDataItemType {
		Title = "Title",
		Image = "Image",
		Id = "Id",
		CreationDate = "CreationDate",
		ModifiedDate = "ModifiedDate",
		Visits = "Visits",
		Comments = "Comments",
		Type = "Type",
		Category = "Category",
		Milestone = "Milestone",
		Access = "Access",
		Space = "Space",
		Region = "Region",
		Division = "Division",
		Department = "Department",
		VotingScore = "VotingScore",
		IdeaLikesCount = "IdeaLikesCount",
		State = "State"
	}
	export enum IdeaListFilterType {
		Category = "Category",
		IdeaType = "IdeaType",
		Milestone = "Milestone",
		State = "State",
		Region = "Region",
		Division = "Division",
		Department = "Department",
		Space = "Space",
		CreationDate = "CreationDate",
		Tag = "Tag",
		SingleChoice = "SingleChoice",
		UserGroups = "UserGroups"
	}
	export enum IdeaListFilterUiType {
		SelectItems = "SelectItems",
		SelectItemsWithSpaceId = "SelectItemsWithSpaceId",
		Custom = "Custom"
	}
	export enum IdeaListViewMode {
		StandardTiles = "StandardTiles",
		SmallTiles = "SmallTiles"
	}
	export enum IdeaListSortingType {
		CreationDate = "CreationDate",
		ModifiedDate = "ModifiedDate",
		Milestone = "Milestone",
		State = "State",
		Visits = "Visits",
		Comments = "Comments",
		Votes = "Votes",
		VotingScore = "VotingScore",
		Relevance = "Relevance"
	}
	export enum EFormBuilderVisability {
		NeverVisible = "NeverVisible",
		AlwaysVisible = "AlwaysVisible",
		VisibleOnEditMode = "VisibleOnEditMode"
	}
	export enum IdeaCenterAction {
		MergeIdeas = "MergeIdeas",
		ChangeState = "ChangeState",
		ChangeCategory = "ChangeCategory",
		ChangeType = "ChangeType",
		DeleteIdeas = "DeleteIdeas",
		Voting = "Voting",
		CreateTasks = "CreateTasks"
	}
	export interface ISimilarIdeasRequest
	{
		spaceId: number;
		title: string;
	}
	export interface IWorkflowStateDto
	{
		id: number;
		stateNameId: string;
		formName: string;
		formId: number;
		formEntryId: any;
		order: number;
		isPrevious: boolean;
		text: string;
	}
	export interface ISetActiveWorkflowStateCommand
	{
		stateName: string;
		ideaId: number;
	}
	export interface IGetExtendWorkflowStateDueDateRequest
	{
		tabId: any;
		ideaId: number;
		stateId: number;
		stateName: string;
	}
	export interface IExtendWorkflowStateDueDateDto
	{
		tabId: any;
		ideaId: number;
		currentStateId: number;
		currentStateName: string;
		dueDate: string;
		maxSelectableDate: string;
		minSelectableDate: string;
		maximumPossibleExtension: string;
		maxDate: string;
		maxNumberOfDaysPerExtension: number;
		remainingNumberOfExtensions: number;
		isExtensionPossible: boolean;
		specialDueDateOverInfoVisible: boolean;
		infoSpecialPrivilagesVisible: boolean;
		normalDueDateOverInfoVisible: boolean;
		extensionDaysInfoVisible: boolean;
		remainingExtensionNumberVisible: boolean;
		commentVisible: boolean;
		maxDateVisible: boolean;
		noExtensionsInfoVisible: boolean;
	}
	export interface IExtendWorkflowStateDueDateCommand
	{
		tabId: any;
		ideaId: number;
		stateId: number;
		stateName: string;
		newDueDate: string;
		comment: string;
	}
	export interface IWorkflowStateId extends CwxBackend.IInt32Identifier
	{
	}
	export interface IWorkflowResult
	{
		stateChanged: boolean;
		message: string;
		resultCode: CwxBackend.WorkflowResultCode;
	}
	export interface IBulkChangeWorkflowResult
	{
		workflowResult: CwxBackend.IWorkflowResult;
		ideaId: any;
	}
	export enum WorkflowResultCode {
		Ok = "Ok",
		InputIgnored = "InputIgnored",
		MissingWorkflow = "MissingWorkflow",
		WaitingForOtherUsers = "WaitingForOtherUsers",
		OkAndNextStateReady = "OkAndNextStateReady"
	}
	export enum FrontendViews {
		IdeaList = "IdeaList",
		IdeaDetails = "IdeaDetails",
		WelcomePage = "WelcomePage",
		IdeaSubmit = "IdeaSubmit",
		IdeaDraft = "IdeaDraft",
		IdeaEdit = "IdeaEdit",
		AccountDetails = "AccountDetails",
		AccountSettings = "AccountSettings",
		AccountNotifications = "AccountNotifications",
		AccountDelegation = "AccountDelegation",
		AccountPassword = "AccountPassword",
		MyIdeasList = "MyIdeasList",
		MyTasks = "MyTasks",
		GlobalIdeaList = "GlobalIdeaList",
		Login = "Login",
		ForgotPassword = "ForgotPassword",
		MyRewards = "MyRewards",
		HtmlPage = "HtmlPage",
		Imprint = "Imprint",
		SpaceHome = "SpaceHome",
		ChallengeHome = "ChallengeHome",
		ChallengeList = "ChallengeList",
		SearchResults = "SearchResults",
		CreateBasedOnCompetitionAnswer = "CreateBasedOnCompetitionAnswer",
		CreateBasedOnAnotherIdea = "CreateBasedOnAnotherIdea",
		ErrorPage = "ErrorPage",
		ScorecardEdit = "ScorecardEdit",
		SubmissionConfirmed = "SubmissionConfirmed",
		SubmissionConfirmedCreateAccount = "SubmissionConfirmedCreateAccount"
	}
	export interface IUpdateUserFrontendViewSettingCommand
	{
		isNewFrontedEnabled: boolean;
		view: CwxBackend.FrontendViews;
	}
	export enum SpaceSidebarType {
		FixedMenuItem = "FixedMenuItem",
		Separator = "Separator",
		CustomMenuItem = "CustomMenuItem"
	}
	export enum SpaceSidebarFixedMenuItemType {
		None = "None",
		Home = "Home",
		AllItems = "AllItems",
		Submit = "Submit",
		Visualizations = "Visualizations",
		Evaluations = "Evaluations",
		DataCenter = "DataCenter",
		Reporting = "Reporting",
		AdminHome = "AdminHome",
		AdminSubmit = "AdminSubmit",
		AI = "AI"
	}
	export interface ISearchRequest
	{
		itemsPerPage: number;
		pageNumber: number;
		sortBy?: CwxBackend.SearchResultsSorting;
		sortDesc?: boolean;
		text?: string;
		spaceIds?: number[];
		filterTypes?: CwxBackend.SearchSetFilterType[];
		tagsIds?: number[];
		currentUser?: any;
	}
	export enum SearchResultsSorting {
		Relevance = "Relevance",
		Date = "Date",
		LastModified = "LastModified"
	}
	export enum SearchSetFilterType {
		Idea = "Idea",
		Campaign = "Campaign",
		ContentPage = "ContentPage",
		UserProfile = "UserProfile",
		Challenge = "Challenge"
	}
	export enum SearchResultType {
		Idea = "Idea",
		Competition = "Competition",
		CompetitionAnswer = "CompetitionAnswer",
		ContentPage = "ContentPage",
		UserProfile = "UserProfile",
		Challenge = "Challenge"
	}
	export interface ISearchResultsDto
	{
		potentialSetFilters: CwxBackend.IPotentialSearchSetFilterDto[];
		pagedSearchResults: CwxBackend.IPagedResultDto<CwxBackend.ISearchResultDto>;
		elapsedTimeInSecondsString: string;
	}
	export interface ISearchResultDto
	{
		title: string;
		titleHighlight: CwxBackend.IHighlightedTextFragmentDto[];
		snippetHighlight: CwxBackend.IHighlightedTextFragmentDto[];
		url: string;
		creationDate: string;
		modifiedDate: string;
		resultType: CwxBackend.SearchResultType;
		filterType: CwxBackend.SearchSetFilterType;
		ideaData?: CwxBackend.ISearchResultIdeaMetadata;
		userProfileData?: CwxBackend.ISearchResultUserProfileMetadata;
		competitionData?: CwxBackend.ISearchResultCompetitionMetadata;
		competitionAnswerData?: CwxBackend.ISearchResultCompetitionAnswerMetadata;
		contentPageData?: CwxBackend.ISearchResultContentPageMetadata;
	}
	export interface IPotentialSearchSetFilterDto
	{
		filterType: CwxBackend.SearchSetFilterType;
		searchResultsCount: number;
		spaceId: number;
		textSingular: string;
		textPlural: string;
	}
	export interface ISearchResultCompetitionAnswerMetadata
	{
		competitionAnswerId: number;
		competitionID: number;
		submitOrder: number;
	}
	export interface ISearchResultCompetitionMetadata
	{
		competitionId: number;
	}
	export interface ISearchResultContentPageMetadata
	{
		pageId: number;
	}
	export interface ISearchResultIdeaMetadata
	{
		ideaId: number;
		title: string;
		state: string;
		stateHexColor: string;
		stateVisible: boolean;
		spaceId: number;
	}
	export interface ISearchResultUserProfileMetadata
	{
		userId: string;
	}
	export interface ICommentsDto
	{
		comments: CwxBackend.ICommentItemDto[];
		commentsCount: number;
		isFollowing: boolean;
		userImageUrl: string;
		isCommentAnonymityEnabled: boolean;
		isCommentsTeamsButtonVisible: boolean;
	}
	export interface ICommentItemDto
	{
		id: number;
		user: CwxBackend.IUserDto;
		editContent: string;
		viewContent: string;
		attachments: CwxBackend.IFileDto[];
		dateCreated: string;
		timeCreated: string;
		dateEdited: string;
		roleName: string;
		totalLikes: number;
		isLiked: boolean;
		isEditActive: boolean;
		isDeleteActive: boolean;
		canUserSeeProfile: boolean;
		commentReplies: CwxBackend.ICommentItemDto[];
	}
	export interface ICreateCommentItemRequest
	{
		content: string;
		fileIds: number[];
	}
	export interface IFileDto
	{
		fileId: number;
		fileIdentifier: any;
		orginalFileName: string;
		fileSize: number;
		filePath: string;
		posterPath: string;
		thumbnailPath: string;
		fileMimeType: string;
		filePreviewPath: string;
		fileIconPath: string;
		isVideoFile: boolean;
	}
	export interface ISearchResultsSpaceSettingsViewModel
	{
		SpaceId: number;
		IsStateVisible: boolean;
	}
	export enum DashboardType {
		None = 0,
		UtilityRewards = 1,
		Activity = 2,
		Process = 3,
		ProcessingTime = 4,
		Financials = 5,
		GamificationBadges = 6,
		Pipelines = 7,
		OpenTasks = 8,
		Tags = 9,
		DataCenter = 10
	}
	export enum ReportingWidgetType {
		Default = "Default",
		State = "State"
	}
	export enum ReportingStateWidgetDataType {
		Numeric = "Numeric",
		Percent = "Percent",
		Grid = "Grid",
		Chart = "Chart"
	}
	export enum ReportingStateWidgetDateRangeType {
		Custom = "Custom",
		LongerThanYear = "LongerThanYear"
	}
	export enum DashboardTreeMode {
		Flat = "Flat",
		Nested = "Nested"
	}
	export enum SpaceDepartmentBehavior {
		Manually = "Manually",
		Automatically = "Automatically",
		Linked = "Linked"
	}
	export enum SpaceDivisionsBehavior {
		Manually = "Manually",
		Automatically = "Automatically",
		Linked = "Linked"
	}
	export interface IDashboardWidgetName
	{
		TotalUtility: CwxBackend.IDashboardWidgetName;
		UtilityPerItem: CwxBackend.IDashboardWidgetName;
		UtilityPerPerson: CwxBackend.IDashboardWidgetName;
		TotalRewards: CwxBackend.IDashboardWidgetName;
		RewardGrid: CwxBackend.IDashboardWidgetName;
		PayoutExport: CwxBackend.IDashboardWidgetName;
		ClosedItems: CwxBackend.IDashboardWidgetName;
		ImplementedItems: CwxBackend.IDashboardWidgetName;
		ImplementationRate: CwxBackend.IDashboardWidgetName;
		RejectedItems: CwxBackend.IDashboardWidgetName;
		NotEligibleItems: CwxBackend.IDashboardWidgetName;
		OpenItems: CwxBackend.IDashboardWidgetName;
		OpenItemsMoreThanAYear: CwxBackend.IDashboardWidgetName;
		ItemsInDecision: CwxBackend.IDashboardWidgetName;
		ItemsInImplementation: CwxBackend.IDashboardWidgetName;
		ProcessGrid: CwxBackend.IDashboardWidgetName;
		TotalPersons: CwxBackend.IDashboardWidgetName;
		Authors: CwxBackend.IDashboardWidgetName;
		ParticipationRate: CwxBackend.IDashboardWidgetName;
		SubmittedItems: CwxBackend.IDashboardWidgetName;
		ItemsPerPerson: CwxBackend.IDashboardWidgetName;
		SubmittedItemsLineChart: CwxBackend.IDashboardWidgetName;
		ActivityGrid: CwxBackend.IDashboardWidgetName;
		TotalProcessingTime: CwxBackend.IDashboardWidgetName;
		TotalProcessingTimeChart: CwxBackend.IDashboardWidgetName;
		TotalProcessingTimeGrid: CwxBackend.IDashboardWidgetName;
		SumsForTypeGroupedByEffect: CwxBackend.IDashboardWidgetName;
		CumulativeSumsForTypesAndEffect: CwxBackend.IDashboardWidgetName;
		SumsForTypeAndEffectGroupedByCategory: CwxBackend.IDashboardWidgetName;
		FinancialGrid: CwxBackend.IDashboardWidgetName;
		GamificationBadgesGrid: CwxBackend.IDashboardWidgetName;
		OpenTasksGrid: CwxBackend.IDashboardWidgetName;
		PortfolioAnalysisChart: CwxBackend.IDashboardWidgetName;
		TagsCloud: CwxBackend.IDashboardWidgetName;
		TagsTrends: CwxBackend.IDashboardWidgetName;
		TagsDetailsGrid: CwxBackend.IDashboardWidgetName;
		DataCenter: CwxBackend.IDashboardWidgetName;
	}
	export interface IStateReportingRequest
	{
		stateIds: number[];
		denominatorStateIds: number[];
		explicitEndStateIds: number[];
		departmentIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		spaceDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		spaceDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isIdeaCountryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		dateRange: CwxBackend.IDateRange;
		spaceId: CwxBackend.ISpaceId;
		dashboardId: CwxBackend.IReportingDashboardId;
		userId: any;
		isRatio: boolean;
		isEndState: boolean;
		dateRangeType: CwxBackend.ReportingStateWidgetDateRangeType;
	}
	export interface ISelectedDepartmentCountRequest
	{
		selectedDepartments: any[];
		departmentIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		dashboardId: number;
		isConfigurationMode: boolean;
	}
	export interface IReportingFinancialsRequest
	{
		departmentIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		dateRange: CwxBackend.IDateRange;
		baseCurrencyId: number;
		spaceId?: CwxBackend.ISpaceId;
		dashboardId: CwxBackend.IReportingDashboardId;
		tabId?: any;
		ideaId?: number;
		userId: any;
	}
	export interface IGroupedStateReportingRequest
	{
		stateIdsGrouping: CwxBackend.IStateGroup[];
		departmentIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		spaceDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		spaceDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isIdeaCountryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		dateRange: CwxBackend.IDateRange;
		spaceId: CwxBackend.ISpaceId;
		dashboardId: CwxBackend.IReportingDashboardId;
		userId: any;
	}
	export interface IFilteredReportingRequest
	{
		departmentIds: any;
		spaceDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		spaceDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isIdeaCountryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		dateRange: CwxBackend.IDateRange;
		spaceId: CwxBackend.ISpaceId;
		dashboardLevelRoles: any[];
	}
	export interface IStateGroup
	{
		header: string;
		systemName: string;
		stateNameIds: CwxBackend.IStateWidgetViewModel[];
		denominatorStateNameIds: CwxBackend.IStateWidgetViewModel[];
		explicitEndStateNameIds: CwxBackend.IStateWidgetViewModel[];
		isRatio: boolean;
		dateRangeType: CwxBackend.ReportingStateWidgetDateRangeType;
		isEndState: boolean;
	}
	export interface IReportingRequest
	{
		departmentIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		spaceDepartmentBehavior: CwxBackend.SpaceDepartmentBehavior;
		spaceDivisionsBehavior: CwxBackend.SpaceDivisionsBehavior;
		isIdeaCountryVisible: boolean;
		isIdeaRegionVisible: boolean;
		isIdeaCompanyVisible: boolean;
		dateRange: CwxBackend.IDateRange;
		spaceId: CwxBackend.ISpaceId;
		dashboardId: CwxBackend.IReportingDashboardId;
		userId: any;
	}
	export interface IDepartmentTreeSelectionItemProxy
	{
		id: number;
		loadChildren: boolean;
	}
	export interface IReportingWidgetData
	{
		value: string;
		error: string;
	}
	export interface ILinearChartData
	{
		series: CwxBackend.ILineSeries[];
		error: string;
	}
	export interface ILineSeries
	{
		name: string;
		data: number[][];
	}
	export interface IDonutChartData
	{
		labels: string[];
		series: number[];
		seriesFormatted: string[];
		isMoney: boolean;
		unit: string;
		error: string;
	}
	export interface IStateWidgetViewModel
	{
		id: number;
		name: string;
		nameId: string;
	}
	export interface IReportingWidgetViewModel
	{
		systemName: string;
		header: string;
		order: number;
		showTotalCompany: boolean;
		widgetType: CwxBackend.ReportingWidgetType;
		dataType: CwxBackend.ReportingStateWidgetDataType;
		dateRangeType: CwxBackend.ReportingStateWidgetDateRangeType;
		states: CwxBackend.IStateWidgetViewModel[];
		denominatorStates: CwxBackend.IStateWidgetViewModel[];
		explicitEndStates: CwxBackend.IStateWidgetViewModel[];
		isEndState: boolean;
		isRatio: boolean;
		isOpenTasksAssignedToColumnVisible: boolean;
		canUserChangeConfiguration: boolean;
		isBatchOperationsEnabled: boolean;
	}
	export interface ITrendRadarDataViewModel
	{
		items: any[];
		sectorAxis: CwxBackend.ITrendRadarAxisViewModel;
		distanceAxis: CwxBackend.ITrendRadarAxisViewModel;
		originalCount: number;
		sectorColors: CwxBackend.ICategoryColorViewModel[];
		distanceColors: CwxBackend.ICategoryColorViewModel[];
		legendViewModel: CwxBackend.ITrendRadarLegendViewModel;
		hasProfile: boolean;
	}
	export interface ITrendRadarAxisViewModel
	{
		name: string;
		isCategory: boolean;
		axisReversed: boolean;
		categories: CwxBackend.IChartCategoryViewModel[];
		minValue: number;
		maxValue: number;
	}
	export interface ITrendRadarLegendViewModel
	{
		bubbleColorDataViewModel: CwxBackend.ICategoryColorsViewModel;
		bubbleRingDataViewModel: CwxBackend.ICategoryColorsViewModel;
		bubbleSizeField: string;
	}
	export interface IChartCategoryViewModel
	{
		categoryId: any;
		categoryNameId: any;
		categoryName: string;
	}
	export interface ICategoryColorsViewModel
	{
		name: string;
		categoryColors: CwxBackend.ICategoryColorViewModel[];
		isCategoryField: boolean;
		isNumericField: boolean;
	}
	export interface IOpenTasksGetExcelRequest
	{
		dashboardId: number;
		spaceId: number;
	}
	export interface ISpaceChallengeWizardTemplateData
	{
		settings: any;
		closeChallengePhaseName: string;
		closeChallengePhaseDate: string;
	}
	export interface IChallengeTimelinePhaseViewModel
	{
		id: number;
		order: number;
		name: string;
		isToDelete: boolean;
		isDirty: boolean;
		nameId: string;
		startDate: string;
		phaseAction: CwxBackend.ICwxSelectListItem;
	}
	export interface IChallengeRequest
	{
		itemsPerPage: number;
		pageNumber: number;
		onlyClosed: boolean;
	}
	export interface IChallengeListRequest
	{
		itemsPerPage: number;
		pageNumber: number;
		spaceState: CwxBackend.ESpaceState;
	}
	export interface IChallengeHomeTab
	{
		url: string;
		content: string;
		id: number;
		header: string;
		icon: string;
		menuItemType: CwxBackend.SpaceSidebarFixedMenuItemType;
	}
	export interface ISpaceChallengeListItem
	{
		title: string;
		isVisible: boolean;
		visitsCount: number;
		id: number;
		visitsCountText: string;
		statusText: string;
		endTextNoHtml: string;
		studyDetailsLink: string;
		imageUrls: { [key:string]: string };
		imageFileId: number;
		commentsCount: number;
		launchingDate: string;
		launchingDateValue: string;
		closingDateValue: string;
		closingSubmissionDateValue: string;
		closingDate: string;
		closingSubmissionDate: string;
		progress: number;
	}
	export interface IChallengesListDto
	{
		listItems: CwxBackend.IPagedResultDto<CwxBackend.ISpaceChallengeListItemDto>;
		addButtonVisible: boolean;
	}
	export interface ISpaceChallengeListItemDto
	{
		id: number;
		title: string;
		status: CwxBackend.ESpaceState;
		endTimeTextNoHtml: string;
		isPublic: boolean;
		imageUrls: { [key:string]: string };
		imageFileId: number;
		commentsCount: number;
		launchingDate: string;
		launchingDateValue: string;
		closingDateValue: string;
		closingSubmissionDateValue: string;
		closingDate: string;
		progress: number;
	}
	export interface IChallengeContributorDto
	{
		user: CwxBackend.IUserDto;
		commentsCount: number;
		itemsCount: number;
	}
	export enum ESpaceState {
		Draft = "Draft",
		Scheduled = "Scheduled",
		Open = "Open",
		Closed = "Closed",
		ClosedSubmission = "ClosedSubmission"
	}
	export interface ICompetitionAnswerRejectionViewModel
	{
		competitionId: number;
		competitionAnswerId: number;
		rejectingUserId: string;
		explanation: string;
		isAnswerRejectionEmailSent: boolean;
		rejectingUserUsername: string;
		auditData: string[];
	}
	export interface ICompetitionAnswersRequestDto
	{
		itemsPerPage: number;
		pageNumber: number;
		competitionId: number;
		showOnlyMyAnswers: boolean;
		sorting: CwxBackend.ECompetitionAnswerListSortingOptions;
		categoryIds: number[];
		searchPhrase: string;
	}
	export interface ICompetitionAnswersResultDto
	{
		pagedCompetitionAnswers: CwxBackend.IPagedResultDto<CwxBackend.ICompetitionAnswerDetailsResultDto>;
		isRatingShown: boolean;
		votingType: CwxBackend.ECompetitionVotingType;
		title: string;
		categories: CwxBackend.ICompetitionCategoryDto[];
		competitionAnswerCategoriesVisible: boolean;
		isCompetitionInClosedMode: boolean;
		isCurrentUserCompetitionAuthorOrManager: boolean;
		sortOptions: CwxBackend.ISelectListEnumItemDto<CwxBackend.ECompetitionAnswerListSortingOptions>[];
		totalAnswersCount: number;
		allAnswersCountWithoutAnyFilters: number;
		allMyAnswersCountWithoutAnyFilters: number;
	}
	export interface ICompetitionCategoryDto
	{
		categoryId: number;
		displayOrder: number;
		value: string;
	}
	export interface ICompetitionAnswerDetailsResultDto
	{
		id: number;
		title: string;
		competitionID: number;
		votingType: CwxBackend.ECompetitionVotingType;
		showAllData: boolean;
		competitionAnswerCategoriesVisible: boolean;
		isRatingShown: boolean;
		isVisible: boolean;
		imageUrls: { [key:string]: string };
		isCompetitionInClosedMode: boolean;
		isIdeaImageEnabled: boolean;
		statistics: CwxBackend.ICompetitionAnswerStatisticsResultDto;
		submitOrder: number;
		answerCategoryTitle: string;
		answerInvisibleByText: string;
		statisticsStarRatingIn2DecimalsFormat: string;
		dateCreatedTimePassedSince: string;
		competitionAnswerUrl: string;
	}
	export interface ICompetitionAnswerStatisticsResultDto
	{
		commentCount: number;
		rank: number;
		percentRank: number;
	}
	export enum ECompetitionVotingType {
		None = "None",
		Pairwise = "Pairwise",
		StarRating = "StarRating"
	}
	export enum ECompetitionAnswerListSortingOptions {
		Newest = "Newest",
		MostCommentsCount = "MostCommentsCount",
		PairwiseHigestScore = "PairwiseHigestScore",
		StarRatingHigestScore = "StarRatingHigestScore",
		ByTitle = "ByTitle"
	}
	export interface IStudiesRequestDto
	{
		itemsPerPage: number;
		pageNumber: number;
		type: CwxBackend.EStudyListType;
		sorting: CwxBackend.EStudyListSortingOptions;
	}
	export interface IStudiesResultDto
	{
		pagedStudiesItems: CwxBackend.IPagedResultDto<CwxBackend.IStudyItemDto>;
	}
	export interface IStudyItemDto
	{
		title: string;
		isVisible: boolean;
		visitsCount: number;
		id: number;
		type: number;
		visitsCountText: string;
		statusText: string;
		endTextNoHtml: string;
		studyDetailsLink: string;
		imageUrls: { [key:string]: string };
		commentsCount: number;
		startDate: string;
		endDate: string;
		progress: number;
	}
	export enum EStudyListType {
		Open = "Open",
		Closed = "Closed"
	}
	export enum EStudyListSortingOptions {
		New = "New",
		Popular = "Popular",
		TimeLeft = "TimeLeft"
	}
	export enum ImageDimensions {
		_25_25 = "_25_25",
		_40_40 = "_40_40",
		_60_60 = "_60_60",
		_100_100 = "_100_100",
		_200_200 = "_200_200",
		_350_350 = "_350_350",
		_350_212 = "_350_212",
		_335_200 = "_335_200",
		_670_400 = "_670_400",
		_750_750 = "_750_750",
		_2000_435 = "_2000_435"
	}
	export class ImageConstants
	{
		public static DefaultListAspectRatio: number = 1.67;
	}
	export class PipelineConstants
	{
		public static MaximumIdeasToProcess: number = 1000;
	}
	export class FeedbackFormConstants
	{
		public static HiddenInputValue: string = `4FDAF9D4F971E08FA7607D70138C4AE0`;
	}
	export enum UserEmailStatus {
		Empty = "Empty",
		Company = "Company",
		Private = "Private"
	}
	export enum Visibility {
		Public = "Public",
		Private = "Private",
		Hidden = "Hidden"
	}
	export interface IUserInfo
	{
		userId: string;
		firstName: string;
		lastName: string;
		email: string;
		userName: string;
		displayName: string;
		cultureCode: string;
		avatarId: number;
		freeCash: number;
		currencySign: string;
		hasNotifications: boolean;
		isAdministrationAreaAvailable: boolean;
		isDeputy: boolean;
		globalRoles: string[];
	}
	export interface IProfileDetailsDto
	{
		userId: string;
		usernameLabel: string;
		username: string;
		displayName: string;
		isUsernameVisible: boolean;
		isUsernamePrivate: boolean;
		isFirstAndLastNameVisible: boolean;
		isFirstAndLastNamePrivate: boolean;
		showExternalLink: boolean;
		externalLink: string;
		externalLinkText: string;
		avatarId: number;
		avatarSrc: string;
		isImageVisible: boolean;
		isImagePrivate: boolean;
		email: string;
		isEmailVisible: boolean;
		isEmailPrivate: boolean;
		jobTitle: string;
		isJobTitleVisible: boolean;
		isJobTitlePrivate: boolean;
		department: string;
		departmentLabel: string;
		isDepartmentVisible: boolean;
		isDepartmentPrivate: boolean;
		employeeType: string;
		employeeTypeLabel: string;
		isEmployeeTypeVisible: boolean;
		isEmployeeTypePrivate: boolean;
		aboutMe: string;
		isAboutMeVisible: boolean;
		isAboutMePrivate: boolean;
		group: string;
		groupLabel: string;
		isGroupVisible: boolean;
		isGroupPrivate: boolean;
		region: string;
		regionLabel: string;
		isRegionVisible: boolean;
		isRegionPrivate: boolean;
		country: string;
		countryLabel: string;
		isCountryVisible: boolean;
		isCountryPrivate: boolean;
		company: string;
		isCompanyVisible: boolean;
		isCompanyPrivate: boolean;
		staffNumber: string;
		isStaffNumberVisible: boolean;
		isStaffNumberPrivate: boolean;
		firstName: string;
		lastName: string;
		isBadgeSectionVisible: boolean;
		isBadgeSectionPrivate: boolean;
		areUserProfileTagsClickable: boolean;
		areExternalLinkVisible: boolean;
		userTagTemplates: CwxBackend.IProfileTagDto[];
		contactFields: CwxBackend.IProfileContactFieldDto[];
		multipleChoiceLists: CwxBackend.IProfileMultipleChoiceListDto[];
		userBadges: CwxBackend.IProfileSpaceBadges[];
	}
	export interface IProfileEditDto
	{
		userId: string;
		avatarId?: number;
		departmentId?: number;
		regionId?: number;
		countryId: number;
		companyId: number;
		employeeTypeId: number;
		divisionId: number;
		firstName: string;
		lastName: string;
		userName: string;
		staffNumber: string;
		job: string;
		email: string;
		aboutMe: string;
		isEmailEditable: boolean;
		isUsernameEditable: boolean;
		isFirstAndLastNameEditable: boolean;
		isImageEditable: boolean;
		isJobTitleEditable: boolean;
		isDepartmentEditable: boolean;
		isEmployeeTypeEditable: boolean;
		isAboutMeEditable: boolean;
		isRegionEditable: boolean;
		isCountryEditable: boolean;
		isCompanyEditable: boolean;
		isStaffNumberEditable: boolean;
		divisions: CwxBackend.ICwxSelectListItem[];
		regions: CwxBackend.ICwxSelectListItem[];
		countries: CwxBackend.ICwxSelectListItem[];
		companies: CwxBackend.ICwxSelectListItem[];
		employeeTypes: CwxBackend.ICwxSelectListItem[];
		userTagTemplates: CwxBackend.IProfileTagDto[];
		contactFields: CwxBackend.IProfileContactFieldEditDto[];
		multipleChoiceLists: CwxBackend.IProfileMultipleChoiceListEditDto[];
	}
	export interface IProfileTagDto
	{
		userTagTemplateId: number;
		order: number;
		content: string;
		visibility: CwxBackend.Visibility;
		isEditable: boolean;
		userTags: CwxBackend.ITagItemDto[];
	}
	export interface IProfileContactFieldDto
	{
		label: string;
		value: string;
		isPrivate: boolean;
	}
	export interface IProfileContactFieldEditDto
	{
		contactDataTemplateId: string;
		content: string;
		label: string;
		isEditable: boolean;
		visibility: CwxBackend.Visibility;
	}
	export interface IProfileMultipleChoiceListDto
	{
		name: string;
		selectedValue: string;
	}
	export interface IProfileMultipleChoiceListEditDto
	{
		id: number;
		name: string;
		items: CwxBackend.ICwxSelectListItem[];
	}
	export interface IProfileSpaceBadges
	{
		spaceId: number;
		spaceName: CwxBackend.ICustomLocaleDto;
		badges: CwxBackend.IBadgeDefinitionDto[];
		allBadges: CwxBackend.IBadgeDefinitionDto[];
		spaceUrl: string;
	}
	export interface IUpdateProfileDetailsCommand
	{
		userId: string;
		username: string;
		usernameLabel: string;
		displayName: string;
		showExternalLink: boolean;
		externalLink: string;
		externalLinkText: string;
		avatarId: number;
		email: string;
		jobTitle: string;
		departmentId: number;
		employeeTypeId: number;
		aboutMe: string;
		group: string;
		regionId: number;
		countryId: number;
		companyId: number;
		staffNumber: string;
		firstName: string;
		lastName: string;
		password: string;
		userTagTemplates: CwxBackend.IProfileTagDto[];
		contactFields: CwxBackend.IProfileContactFieldEditDto[];
		multipleChoiceLists: CwxBackend.IProfileMultipleChoiceListEditDto[];
	}
	export interface IChangePasswordDto
	{
		requireOldPassword: boolean;
		userToChangeId: string;
		userToChangeDisplayName: string;
	}
	export interface IChangePasswordCommand
	{
		oldPassword: string;
		password: string;
		passwordRepeated: string;
		userId: string;
	}
	export interface IAccountSettingsDto
	{
		userId: string;
		userDisplayName: string;
		displayLanguage: string;
		allDisplayLanguages: CwxBackend.ICwxSelectListItem[];
		isPreferredLanguageVisible: boolean;
		preferredLanguage: string;
		isDeleteButtonDisabled: boolean;
		allPreferredLanguages: CwxBackend.ICwxSelectListItem[];
	}
	export interface IAccountNavigationSettingsDto
	{
		isChangePasswordVisible: boolean;
		isTwoFactorAuthenticationVisible: boolean;
		isDelegationsVisible: boolean;
	}
	export interface IUpdateAccountSettingsCommand
	{
		userId: string;
		displayLanguage: string;
		preferredLanguage: string;
	}
	export interface IResetOnboardingCommand
	{
		userId: string;
	}
	export interface IDeleteUserCommand
	{
		password: string;
	}
	export interface IAccountNotificationSettingsDto
	{
		userId: string;
		userDisplayName: string;
		userEmail: string;
		sendNotificationAboutNewCommentOnMyIdea: boolean;
		sendNotificationAboutNewCommentOnIdeaIFollow: boolean;
		sendNotificationAboutNewCommentOnMyCompetitionAnswer: boolean;
		sendNotificationAboutNewCommentOnCompetitionAnswerIFollow: boolean;
		sendNotificationAboutNewContentMatchingYourTags: boolean;
	}
	export interface IDelegationDataDto
	{
		userId: string;
		displayName: string;
		currentDelegators: CwxBackend.IDelegationDto[];
		currentDeputies: CwxBackend.IDelegationDto[];
	}
	export interface IDelegationDto
	{
		user: CwxBackend.IUserDto;
		startDate: string;
		endDate: string;
	}
	export interface ISetOwnDeputyCommand
	{
		delegatorId: string;
		deputyId: string;
		scheduledEndDate: string;
	}
	export interface IEndOwnDelegationCommand
	{
		delegatorId: string;
		deputyId: string;
	}
	export interface IUpdateAccountNotificationSettingsCommand
	{
		userId: string;
		sendNotificationAboutNewCommentOnMyIdea: boolean;
		sendNotificationAboutNewCommentOnIdeaIFollow: boolean;
		sendNotificationAboutNewCommentOnMyCompetitionAnswer: boolean;
		sendNotificationAboutNewCommentOnCompetitionAnswerIFollow: boolean;
		sendNotificationAboutNewContentMatchingYourTags: boolean;
	}
	export class SystemRoleNames
	{
		public static SuperAdmin: string = `Super Admin`;
		public static CustomerAdmin: string = `Customer Admin`;
		public static ChallengeCreator: string = `Challenge Creator`;
		public static Guest: string = `Guest`;
		public static Public: string = `Public`;
		public static SuperAdminOrCustomerAdmin: string = `Super Admin, Customer Admin`;
	}
	export interface ILoginViewModel extends CwxBackend.IPageViewModel
	{
		userName: string;
		password: string;
		rememberMe: boolean;
		termsOfUseViewModel: CwxBackend.IPageViewModel;
		isUserRegistration: boolean;
		userNameLabel: string;
		loginPrompt: string;
		ssoLoginButtonLabel: string;
		ssoLoginButtonDescriptionLabel: string;
		userAgent: string;
	}
	export interface IForgotPasswordViewModel
	{
		email: string;
	}
	export interface IResetPasswordViewModel
	{
		code: string;
		email: string;
		password: string;
		passwordRepeated: string;
	}
	export interface IRegisterViewModel extends CwxBackend.IRegistrationProfileViewModel
	{
		userNameLabel: string;
		userName: string;
		email: CwxBackend.IEmailModel;
		isActivationEmailRequired: boolean;
		password: string;
		isPolicyAccepted: boolean;
		confirmPassword: string;
	}
	export interface ILoginReplayDto
	{
		routeUrl: string;
		redirectUrl: string;
	}
	export interface IResetPasswordReplayDto
	{
		routeUrl: string;
	}
	export interface IRegisterNewUserReplayDto
	{
		routeUrl: string;
		isActivationEmail: boolean;
	}
	export interface IPageViewModel
	{
		id: number;
		title: string;
		content: string;
		supportEmail: string;
	}
	export interface IEmailModel
	{
		value: string;
	}
	export interface IRegistrationProfileViewModel
	{
		AppendSupportLinkToErrorMessage: boolean;
		isErrorMessageVisible: boolean;
		errorMessage: string;
		selectFields: CwxBackend.IRegistrationProfileSelectFieldViewModel[];
		textFields: CwxBackend.IRegistrationProfileTextFieldViewModel[];
		departmentField: CwxBackend.IRegistrationProfileDepartmentSelectFieldViewModel;
		staffNumberField: CwxBackend.IRegistrationProfileStaffNumberFieldViewModel;
	}
	export interface IRegistrationProfileFieldViewModel
	{
		order: number;
		contactTemplateItemId: number;
		label: string;
	}
	export interface IRegistrationProfileTextFieldViewModel extends CwxBackend.IRegistrationProfileFieldViewModel
	{
		value: string;
	}
	export interface IRegistrationProfileSelectFieldViewModel extends CwxBackend.IRegistrationProfileFieldViewModel
	{
		value: number;
		options: CwxBackend.ICwxSelectListItem[];
		showSearch: boolean;
	}
	export interface IRegistrationProfileStaffNumberFieldViewModel extends CwxBackend.IRegistrationProfileFieldViewModel
	{
		value: string;
	}
	export interface IRegistrationProfileDepartmentSelectFieldViewModel extends CwxBackend.IRegistrationProfileFieldViewModel
	{
		departmentId: number;
		departmentName: string;
	}
	export interface IRegisterNewUserDto extends CwxBackend.IRegisterNewUserProfileDto
	{
		userNameLabel?: string;
		userName?: string;
		email?: CwxBackend.IEmailModel;
		isActivationEmailRequired?: boolean;
		password?: string;
		confirmPassword?: string;
		isPolicyAccepted?: boolean;
	}
	export interface IRegisterNewUserProfileDto
	{
		AppendSupportLinkToErrorMessage: boolean;
		isErrorMessageVisible?: boolean;
		errorMessage?: string;
		selectFields?: CwxBackend.IRegistrationProfileSelectFieldViewModel[];
		textFields?: CwxBackend.IRegistrationProfileTextFieldViewModel[];
		departmentField?: CwxBackend.IRegistrationProfileDepartmentSelectFieldViewModel;
		staffNumberField?: CwxBackend.IRegistrationProfileStaffNumberFieldViewModel;
	}
	export interface IExternalLoginConfirmationDto
	{
		externalUserDetailsEditor: CwxBackend.IExternalUserDetailsEditor;
		redirectUrl: string;
	}
	export interface IExternalUserDetailsEditor
	{
		email: string;
		isEmailEditable: boolean;
		usernameLabel: string;
		username: string;
		isUsernameEditable: boolean;
		firstName: string;
		isFirstNameEditable: boolean;
		lastName: string;
		isLastNameEditable: boolean;
		staffNumber: string;
		isStaffNumberEditable: boolean;
		department: string;
		departmentLabel: string;
		isDepartmentEditable: boolean;
		externalDepartmentId: string;
		isExternalDepartmentIdEditable: boolean;
		contactData: { [key:string]: any };
		externalReferences: { [key:string]: string };
	}
	export interface IExternalLoginConfirmationReplayDto
	{
		redirectUrl: string;
	}
	export interface ISpaceAccessRule
	{
		id: number;
		nameId: string;
	}
	export interface IAccessRuleConditions
	{
		accessRuleNameId: string;
		conditions: CwxBackend.IAccessRuleCondition[];
		accessRuleProperties: CwxBackend.ICwxSelectListItem[];
		accessRuleOperators: CwxBackend.ICwxSelectListItem[];
	}
	export interface IAccessRuleCondition
	{
		property: CwxBackend.AccessRuleProperty;
		operator: CwxBackend.AccessRuleOperator;
		values: string[];
		userNamesFile: any;
		selectedCulture: string;
	}
	export interface IAccessRule
	{
		id: number;
		name: string;
		spaceId: number;
		conditions: CwxBackend.IAccessRuleCondition[];
	}
	export enum AccessRuleProperty {
		RoleNameId = "RoleNameId",
		DepartmentNameId = "DepartmentNameId",
		UserName = "UserName",
		RegionNameId = "RegionNameId",
		EmployeeTypeNameId = "EmployeeTypeNameId"
	}
	export enum AccessRuleOperator {
		EqualsTo = "EqualsTo",
		Contains = "Contains",
		StartWith = "StartWith",
		EndWith = "EndWith"
	}
	export interface ISearchRolesRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
		filter: CwxBackend.ISearchRolesRequestFilter;
	}
	export interface ISearchRolesRequestFilter
	{
		roleKinds: CwxBackend.RoleKind[];
	}
	export interface IRolesPickerResultModel
	{
		roles: CwxBackend.IRolesViewModel[];
		hasMoreRolesItems: boolean;
	}
	export interface IRolesViewModel
	{
		nameId: string;
		kind: CwxBackend.RoleKind;
	}
	export enum RoleKind {
		Global = "Global",
		Idea = "Idea",
		Department = "Department",
		IdeaUser = "IdeaUser",
		Division = "Division",
		Region = "Region",
		Space = "Space",
		Company = "Company",
		Category = "Category",
		Country = "Country",
		User = "User",
		EmployeeType = "EmployeeType",
		Type = "Type"
	}
	export interface ISearchRegionsRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface IRegionsPickerResultModel
	{
		regions: CwxBackend.IRegionsViewModel[];
		hasMoreRegionsItems: boolean;
	}
	export interface IRegionsViewModel
	{
		nameId: string;
		name: string;
	}
	export interface ICreateRoleAssignmentRequest
	{
		roleId: number;
		isRoleUnique: boolean;
		roleKind: CwxBackend.RoleKind;
		objects: CwxBackend.ICwxSelectListItem[];
		userNames: string[];
	}
	export interface IDeleteRoleAssignmentsRequest
	{
		assignments: CwxBackend.IDeleteRoleModel[];
	}
	export interface IDeleteRoleModel
	{
		roleId: number;
		roleKind: CwxBackend.RoleKind;
		userId: string;
	}
	export interface ISearchEmployeeTypesRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface IEmployeeTypesPickerResultModel
	{
		employeeTypes: CwxBackend.IEmployeeTypesViewModel[];
		hasMoreEmployeeTypesItems: boolean;
	}
	export interface IEmployeeTypesViewModel
	{
		nameId: string;
		name: string;
	}
	export interface IRolesForAssignUserModel
	{
		roles: CwxBackend.IRolePickerViewModel[];
	}
	export interface IRolePickerViewModel
	{
		id: number;
		name: string;
		kind: CwxBackend.RoleKind;
		isUnique: boolean;
	}
	export interface ISearchCompaniesRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface ICompaniesPickerResultModel
	{
		companies: CwxBackend.ICompanyViewModel[];
		hasMoreCompaniesItems: boolean;
	}
	export interface ICompanyViewModel
	{
		nameId: string;
		name: string;
	}
	export interface ISearchSpacesRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface ISpacesPickerResultModel
	{
		items: CwxBackend.ISpacesViewModel[];
		hasMoreItems: boolean;
	}
	export interface ISpacesViewModel
	{
		nameId: string;
		name: string;
	}
	export interface IRoleAssignmentsGridViewModel
	{
		originalUsername: string;
		username: string;
		userFullname: string;
		email: string;
		level: string;
		role: string;
		roleId: number;
		objectLabel: string;
		objectNameId: string;
		userId: string;
		roleKind: CwxBackend.RoleKind;
	}
	export interface ISearchCountriesRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface ICountriesPickerResultModel
	{
		items: CwxBackend.ICountriesViewModel[];
		hasMoreItems: boolean;
	}
	export interface ICountriesViewModel
	{
		nameId: string;
		name: string;
	}
	export interface ISearchDivisionsRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface IDivisionsPickerResultModel
	{
		items: CwxBackend.IDivisionsViewModel[];
		hasMoreItems: boolean;
	}
	export interface IDivisionsViewModel
	{
		id: number;
		name: string;
	}
	export interface ISearchIdeaCategoriesForPickerRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface ISearchIdeaTypesForPickerRequest
	{
		query: string;
		pageNumber: number;
		pageSize: number;
	}
	export interface IIdeaCategoriesPickerResultModel
	{
		items: CwxBackend.IIdeaCategoriesViewModel[];
		hasMoreItems: boolean;
	}
	export interface IIdeaTypesPickerResultModel
	{
		items: CwxBackend.IIdeaTypesViewModel[];
		hasMoreItems: boolean;
	}
	export interface IIdeaTypesViewModel
	{
		nameId: string;
		name: string;
	}
	export interface IIdeaCategoriesViewModel
	{
		nameId: string;
		name: string;
	}
	export interface IFeedbackFormDto
	{
		title: string;
		message: string;
	}
	export interface IGuestFeedbackFormDto extends CwxBackend.IFeedbackFormDto
	{
		feedbackAuthorEmail: string;
		name: string;
	}
	export enum UserPickerType {
		SubmitFormPickAuthor = "SubmitFormPickAuthor",
		SubmitFormPickLineManager = "SubmitFormPickLineManager",
		UserReplacement = "UserReplacement",
		SubmitEvaluators = "SubmitEvaluators"
	}
	export interface IUserPickerContextDto
	{
		spaceId: number;
		type: CwxBackend.UserPickerType;
	}
	export interface IUserPickerResultDto
	{
		users: CwxBackend.IUserDto[];
		moreUsersExist: boolean;
		isSearchResultsLimited: boolean;
	}
	export interface IUserViewModel
	{
		id: string;
		email: string;
		username: string;
		identityUsername: string;
		staffnumber: string;
		firstName: string;
		lastName: string;
		isSelected: boolean;
		userImageId: number;
		imageUrl: string;
		isVisible: boolean;
		showProfileUrl: boolean;
		onlyUserCanSeeSelf: boolean;
		isInactive: boolean;
		badgeCount: number;
		departmentId: number;
		department: string;
		company: string;
		division: string;
		country: string;
		lineManager: CwxBackend.IUserViewModel;
		displayName: string;
	}
	export interface IUserPickerResultViewModel
	{
		users: CwxBackend.IUserViewModel[];
		moreUsersExist: boolean;
		isSearchResultsLimited: boolean;
	}
	export interface IUserFindRequest
	{
		userListSource: string;
		query: string;
		pageNumber: number;
		pageSize: number;
		ignoredUsersIds: string[];
		usersPool: string[];
		contextData: CwxBackend.IUserPickerContextDto;
		formFieldId?: number;
		ideaId?: number;
	}
	export interface IPeoplePickerDto
	{
		listOfPickedPersons: CwxBackend.IUserDto[];
		isGraphSearch: boolean;
		maxUserToPick: number;
		label: string;
		showLabel: boolean;
		showAssigneMyselfButton: boolean;
		showSelectUserButton: boolean;
		isUserSelectionEnabled: boolean;
	}
	export interface IUserDto
	{
		id: string;
		email: string;
		username: string;
		firstName: string;
		lastName: string;
		isSelected: boolean;
		userImageId: number;
		imageUrl: string;
		isVisible: boolean;
		showProfileUrl: boolean;
		onlyUserCanSeeSelf: boolean;
		badgeCount: number;
		departmentId: number;
		department: string;
		company: string;
		division: string;
		country: string;
		lineManager: CwxBackend.IUserDto;
		isDeactivated: boolean;
		isDeleted: boolean;
		displayName: string;
	}
	export interface IUserPickerDto
	{
		id: string;
		email: string;
		username: string;
	}
	export enum CurrencyEnum {
		EUR = 1,
		USD = 2,
		PT = 3,
		PKT = 4
	}
	export interface ICurrencyExchangeRateViewModel
	{
		id: number;
		currencyFrom: CwxBackend.ICurrencyCodeViewModel;
		currencyTo: CwxBackend.ICurrencyCodeViewModel;
		value: number;
		createdAt: string;
	}
	export interface ICurrencyExchangeRateGridViewModel
	{
		currencyFrom: CwxBackend.ICurrencyViewModel;
		values: { [key:number]: number };
	}
	export interface ICurrencyViewModel
	{
		id: number;
		description: string;
		displayLabel: string;
		code: string;
		order: number;
	}
	export interface IGetExchangeRatesResponse
	{
		exchangeRates: CwxBackend.ICurrencyExchangeRateGridViewModel[];
	}
	export interface ICurrencyCodeViewModel
	{
		id: number;
		code: string;
	}
	export interface IWebLinkViewModel
	{
		name: string;
		url: string;
	}
	export interface IIdeaLinkDisplayDto
	{
		id: number;
		ideaId: number;
		title: string;
		state: string;
		stateColor: string;
		ideaUrl: string;
		imageUrl: string;
		spaceId: number;
		spaceName: string;
		linkType: CwxBackend.LinkType;
	}
	export interface ISpaceLinkDisplayDto
	{
		id: number;
		ideaId?: number;
		title: string;
		state: string;
		stateColor: string;
		ideaUrl: string;
		imageUrl: string;
		spaceId?: number;
		spaceName: string;
		linkType: CwxBackend.LinkType;
	}
	export interface IIdeaLinkGroupDto
	{
		linkType: CwxBackend.LinkType;
		name: string;
		links: CwxBackend.IIdeaLinkDisplayDto[];
	}
	export interface IIdeaLookupDto
	{
		ideaId: number;
		title: string;
		highlightedTitle: string;
		highlightedNameId: string;
		spaceName: string;
	}
	export interface ILinksFromSpaceCountDto
	{
		spaceId: number;
		spaceName: string;
		count: number;
	}
	export interface IGetIdeaLinksResponse
	{
		linkGroups: CwxBackend.IIdeaLinkGroupDto[];
		linksBySpace: CwxBackend.ILinksFromSpaceCountDto[];
		totalCount: number;
	}
	export interface IGetSpaceLinksResponse
	{
		spaceLinks: CwxBackend.ISpaceLinkDisplayDto[];
		linksBySpace: CwxBackend.ILinksFromSpaceCountDto[];
		totalCount: number;
	}
	export interface IIdeaLookupRequest
	{
		phrase: string;
		excludedIds: number[];
		ideaId?: number;
		spaceId?: number;
	}
	export enum LinkType {
		RelatesTo = "RelatesTo",
		Duplicates = "Duplicates",
		IsDuplicatedBy = "IsDuplicatedBy",
		IsParentOf = "IsParentOf",
		IsChildOf = "IsChildOf",
		WebLink = "WebLink"
	}
	export interface IGetLinkedIdeasForIdeaRequest
	{
		ideaId: number;
		page?: number;
		spaceIdFilter?: number;
	}
	export interface IGetLinkedIdeasForSpaceRequest
	{
		spaceId: number;
		page?: number;
		spaceIdFilter?: number;
	}
	export interface IPostNewIdeaLinksRequest
	{
		fromIdeaId: number;
		toIdeasIds: number[];
		linkType: CwxBackend.LinkType;
	}
	export interface IPostNewIdeaWebLinkRequest
	{
		ideaIdValue: number;
		name: string;
		url: string;
	}
	export interface IPostNewSpaceLinksRequest
	{
		spaceId: number;
		toIdeasIds: number[];
	}
	export interface IPostNewSpaceWebLinkRequest
	{
		spaceIdValue: number;
		name: string;
		url: string;
	}
	export enum FinancialEffect {
		Benefit = "Benefit",
		Cost = "Cost"
	}
	export interface IDepartmentsRequestDto
	{
		ideaTabId?: any;
		parentDepartmentId?: number;
	}
	export interface IDepartmentTreeSelectItem
	{
		id: number;
		nameId: string;
		label: string;
		children: CwxBackend.IDepartmentTreeSelectItem[];
		hasChildren: boolean;
		isDeleted: boolean;
		isVisible: boolean;
		isAllowed: boolean;
		hasSpaceAccess: boolean;
		hasSelectedDescendants: boolean;
	}
	export interface IFinancialEntriesQueryDto
	{
		ideaTabId: any;
		ideaId: number;
	}
	export interface IFinancialEntryDto
	{
		id: number;
		date: string;
		category: CwxBackend.IFinancialCategoryDto;
		type: CwxBackend.IFinancialTypeDto;
		department: CwxBackend.IDepartmentTreeSelectItem;
		description: string;
		amount: CwxBackend.ICurrencyValueDto;
		user: CwxBackend.IFinancialUserDto;
		fileAttachments: CwxBackend.ISelectedFileViewModel[];
	}
	export interface IFinancialsConfigurationDto
	{
		spaceId: number;
		tabId: any;
		allCategories: CwxBackend.IFinancialCategoryDto[];
		allCurrencies: CwxBackend.ICurrencyDto[];
		allTypes: CwxBackend.IFinancialTypeDto[];
		descriptionHtml: string;
		defaultCurrency: CwxBackend.ICurrencyDto;
		canUserEdit: boolean;
	}
	export interface IFinancialCategoryDto
	{
		categoryId: number;
		text: string;
	}
	export interface ICurrencyDto
	{
		currencyId: number;
		currencySymbol: string;
	}
	export interface ICurrencyValueDto
	{
		currencyId: number;
		amount: number;
	}
	export interface IFinancialTypeDto
	{
		typeId: number;
		text: string;
	}
	export interface IFinancialUserDto
	{
		userId: string;
		displayName: string;
	}
	export interface IFinancialAttachmentDto
	{
		fileId: number;
		text: string;
	}
	export interface IFinancialEntryCreateUpdateDto
	{
		financialEntryId: number;
		date: string;
		ideaTabId: any;
		ideaId: number;
		categoryId: number;
		typeId: number;
		departmentId: number;
		description: string;
		amount: CwxBackend.ICurrencyValueDto;
		fileAttachmentIds: number[];
	}
	export interface ISumsForTypeGroupedByEffectDto
	{
		type: CwxBackend.IFinancialTypeDto;
		sumsForEffect: CwxBackend.ISumForEffectDto[];
		currencySign: string;
	}
	export interface ISumForEffectDto
	{
		sum: number;
		effectValue: CwxBackend.FinancialEffect;
		effectText: string;
	}
	export interface ISumsForTypeAndEffectGroupedByCategoryDto
	{
		type: CwxBackend.IFinancialTypeDto;
		sumsForCategory: CwxBackend.ISumForCategory[];
		effectValue: CwxBackend.FinancialEffect;
		effectText: string;
		currencySign: string;
	}
	export interface ISumForCategory
	{
		category: CwxBackend.IFinancialCategoryDto;
		sum: number;
	}
	export interface ICumulativeSumsForTypesAndEffectDto
	{
		type: CwxBackend.IFinancialTypeDto;
		cumulativeSums: CwxBackend.ICumulativeSum[];
		effectText: string;
		effectValue: CwxBackend.FinancialEffect;
		currencySign: string;
		currencyCode: string;
		currencySymbol: string;
		currentCultureName: string;
	}
	export interface ICumulativeSum
	{
		date: string;
		sum: number;
	}
	export interface IBadgeDefinitionDto
	{
		id: number;
		name: CwxBackend.ICustomLocaleDto;
		rules: CwxBackend.IBadgeRuleDto[];
		order: number;
		iconClass: string;
		mainColor: string;
		secondaryColor: string;
		isActive: boolean;
		isLegacy: boolean;
	}
	export interface IBadgeRuleDto
	{
		id: number;
		spaceId: number;
		description: CwxBackend.ICustomLocaleDto;
		isActive: boolean;
	}
	export interface IGamificationBadgeReportingGridItemViewModel
	{
		Name: string;
		IconClass: string;
		MainColor: string;
		SecondaryColor: string;
	}
	export interface IGamificationBadgeReportingViewModel
	{
		id: number;
		name: string;
		isActive: boolean;
		isDeleted: boolean;
	}
	export enum UserFieldType {
		System = 0,
		UserTag = 1,
		ContactData = 2
	}
	export interface IDecimalFormulaResponse
	{
		formula: string;
		value: number;
		formattedValue: string;
	}
	export interface IDecimalFormulasRequest
	{
		formulas: string[];
		variables: any[];
	}
	export interface IBooleanFormulaRequest
	{
		formula: string;
		variables: CwxBackend.IKeyValuePair[];
	}
	export interface IBooleanFormulasRequest
	{
		formulas: string[];
		variables: CwxBackend.IKeyValuePair[];
	}
	export interface IBooleanFormulasResponse
	{
		calculatedFormulas: any[];
	}
	export interface ICalculateFormulasRequest
	{
		formulas: string[];
		variables: { [key:string]: string };
	}
	export interface IPeopleListSettingsDto
	{
		filterTypes: CwxBackend.PeopleListFilterType[];
		allMetadata: CwxBackend.IPeopleListAllMetadataDto;
	}
	export interface IPeopleListAllMetadataDto
	{
		filters: CwxBackend.IPeopleListFilterItemDto[];
	}
	export interface IPeopleListFilterItemDto
	{
		type: CwxBackend.PeopleListFilterType;
		text: string;
		uiType: CwxBackend.PeopleListFilterUiType;
	}
	export interface IPeopleRequestDto
	{
		itemsPerPage: number;
		pageNumber: number;
		searchPhrase?: string;
		tagIds?: string;
	}
	export interface IPeopleItemDto
	{
		userId: string;
		imageUrl: string;
		displayName: string;
		departmentName: string;
		job: string;
		userDescription: string;
		jobDepartment: string;
		isUserProfileAccessEnabled: boolean;
		areUserProfileTagsClickable: boolean;
		userTags: CwxBackend.ITagItemDto[];
	}
	export enum PeopleListFilterType {
		Tag = "Tag"
	}
	export enum PeopleListFilterUiType {
		Custom = "Custom"
	}
	export interface IPipelineIdeaViewModel
	{
		ideaId: number;
		ideaTitle: string;
		ideaCreatedDate: string;
		ideaLastModifiedDate: string;
		pointDate: string;
		xAxisValue: string;
		xAxisColor: string;
		xAxisChildValue: string;
		xAxisChildColor: string;
		yAxisValue: string;
		yAxisColor: string;
		yAxisChildValue: string;
		yAxisChildColor: string;
		primaryBubbleSizeValue: number;
		secondaryBubbleSizeValue: number;
		bubbleColorValue: string;
		bubbleColor: string;
		bubbleRingValue: string;
		department: string;
	}
	export interface IPipelineIdeasViewModel
	{
		ideas: CwxBackend.IPipelineIdeaViewModel[];
		skippedIdeasIds: number[];
		dateRange: CwxBackend.IDateRange;
	}
	export interface IPipelineViewModel
	{
		id: any;
		profileName: string;
		isDefaultView: boolean;
		showListOfEntriesAsLegend: boolean;
		xAxisName: string;
		xAxisIsNumeric: boolean;
		xAxisIsCategory: boolean;
		xAxisGridLines: boolean;
		xAxisReversed: boolean;
		xAxisRhombusBoxType: boolean;
		xAxisTextStyleLight: boolean;
		xAxisChildTextStyleLight: boolean;
		xAxisMin: number;
		xAxisMax: number;
		xAxisCategories: CwxBackend.ICategoryColorViewModel[];
		xAxisChildName: string;
		xAxisChildIsNumeric: boolean;
		xAxisChildIsCategory: boolean;
		xAxisChildMin: number;
		xAxisChildMax: number;
		xAxisChildCategories: CwxBackend.ICategoryColorViewModel[];
		yAxisName: string;
		yAxisIsNumeric: boolean;
		yAxisIsCategory: boolean;
		yAxisGridLines: boolean;
		yAxisReversed: boolean;
		yAxisRhombusBoxType: boolean;
		yAxisTextStyleLight: boolean;
		yAxisChildTextStyleLight: boolean;
		yAxisMin: number;
		yAxisMax: number;
		yAxisCategories: CwxBackend.ICategoryColorViewModel[];
		yAxisChildName: string;
		yAxisChildIsNumeric: boolean;
		yAxisChildIsCategory: boolean;
		yAxisChildMin: number;
		yAxisChildMax: number;
		yAxisChildCategories: CwxBackend.ICategoryColorViewModel[];
		primaryBubbleSizeName: string;
		secondaryBubbleSizeName: string;
		bubbleColorName: string;
		bubbleRingName: string;
		bubbleColorCategories: CwxBackend.ICategoryColorViewModel[];
		bubbleRingMinMax: CwxBackend.IBubbleRingMinMaxViewModel;
		bubbleRingCategories: CwxBackend.ICategoryColorViewModel[];
		ideasViewModel: CwxBackend.IPipelineIdeasViewModel;
		dashboardId: CwxBackend.IReportingDashboardId;
	}
	export interface IBubbleRingMinMaxViewModel
	{
		min: number;
		max: number;
	}
	export interface IProfileToSelectViewModel
	{
		id: any;
		name: string;
		isDefaultView: boolean;
		isUserLastView: boolean;
		dashboardId: number;
		requireConfiguration: boolean;
	}
	export interface IPipelineDataRequest
	{
		departmentsIds: CwxBackend.IDepartmentTreeSelectionItemProxy[];
		reportingDashboardId: CwxBackend.IReportingDashboardId;
		userId: any;
		stateIds: CwxBackend.IWorkflowStateId[];
		dateRange: CwxBackend.IDateRange;
		spaceId: CwxBackend.ISpaceId;
		profileId: CwxBackend.IProfileId;
		compareDates: boolean;
	}
	export interface IPipelineHistoryIdeaViewModel
	{
		eventDate: string;
		xAxisValue: string;
		yAxisValue: string;
		primaryBubbleSizeValue: number;
		secondaryBubbleSizeValue: number;
		bubbleColorValue: string;
		bubbleRingValue: string;
	}
	export interface ICategoryColorViewModel
	{
		categoryId: any;
		categoryName: string;
		color: string;
		categoryNameId: any;
	}
	export enum ProfileType {
		ColumnsProfile = 0,
		PortfolioProfile = 1,
		PipelineProfile = 2,
		VisualizationProfile = 3
	}
	export interface IGuidIdentifier
	{
		Value: any;
	}
	export interface IInt32Identifier
	{
		Value: number;
	}
	export interface IProfileId extends CwxBackend.IGuidIdentifier
	{
	}
	export interface ISpaceId extends CwxBackend.IInt32Identifier
	{
	}
	export interface IReportingDashboardId extends CwxBackend.IInt32Identifier
	{
	}
	export interface IProfileOfColumnsRequest
	{
		profileId: any;
		dashboardId: number;
		evaluationId: number;
		visualizationId: number;
	}
	export interface IVisualizationListItemViewModel
	{
		id: number;
		title: string;
		description: string;
		order: number;
		footerColor: string;
		userScopeTitle: string;
		publishStateTitle: string;
	}
	export interface IUserTagTemplateViewModel
	{
		userTagTemplateId: number;
		order: number;
		content: string;
		visibility: CwxBackend.Visibility;
		isEditable: boolean;
		userTags: CwxBackend.ITagViewModel[];
	}
	export interface ITagViewModel
	{
		tagId: number;
		tagName: string;
	}
	export interface IManageTagsViewModel
	{
		canUserGenerateTags: boolean;
		areUserProfileTagsClickable: boolean;
	}
	export interface ITagsSearchRequestDto
	{
		limitQuantity: number;
		query: string;
	}
	export interface ITagsFrequencyViewModel
	{
		id: number;
		name: string;
		tagType: number;
		items: any[];
	}
	export interface ITagItemDto
	{
		tagId: number;
		tagName: string;
	}
	export interface ICreateTagCommand
	{
		tagName: string;
	}
	export enum TeamApplicationStatus {
		Pending = "Pending",
		Approved = "Approved",
		Rejected = "Rejected"
	}
	export enum WorkflowRewardProperty {
		RewardEligibility = "RewardEligibility",
		Multiplier = "Multiplier",
		Recognition = "Recognition",
		Reward = "Reward",
		Utility = "Utility",
		UtilType = "UtilType",
		Engagement = "Engagement",
		Proximity = "Proximity",
		NonCompFactor1 = "NonCompFactor1",
		NonCompFactor2 = "NonCompFactor2"
	}
	export interface ILiveRewardCalculationRequest
	{
		ideaId: number;
		utilityType: string;
		utility: number;
		utilityCurrencyId: number;
		utilityDictionaryId: string;
		reward: number;
		rewardCurrencyId: number;
		recognition: number;
		recognitionCurrencyId: number;
		rewardEligibility: number;
		multiplier: number;
		nonCompFactor1: string;
		nonCompFactor2: string;
		proximity: string;
		engagement: string;
	}
	export interface ITeamApplicationVisibilityDto
	{
		isTeamRequestVisible: boolean;
		isJoinTeamVisible: boolean;
		isSeeAllRequestsVisible: boolean;
		userApplicationExists: boolean;
	}
	export interface ICreateTeamApplicationDto
	{
		userId?: string;
		ideaId: number;
		requestContent: string;
	}
	export interface ICheckApplicationDto
	{
		requirements: string;
		requestContent: string;
		responseContent: string;
		status: CwxBackend.TeamApplicationStatus;
	}
	export interface IAllApplicationsDto
	{
		requirements: string;
		allApplications: CwxBackend.ITeamApplicationDto[];
	}
	export interface ITeamApplicationDto
	{
		id: number;
		userId: string;
		userImageId: number;
		username: string;
		email: string;
		requestContent: string;
		responseContent: string;
		status: CwxBackend.TeamApplicationStatus;
	}
	export interface ITeamApplicationResponseDto
	{
		teamApplicationId: number;
		responseContent: string;
		status: CwxBackend.TeamApplicationStatus;
	}
	export interface IScorecardIdeaListDto
	{
		id: number;
		title: string;
		imageUrl: string;
		isCompleted: boolean;
	}
	export interface IScorecardDefinitionDto
	{
		pageTitle: string;
		isReadOnly: boolean;
		spaceId: number;
		spaceDisplayName: string;
		scorecardId: number;
		furthestSavedScorecardWizardStep: CwxBackend.ScorecardWizardStep;
		instructions: CwxBackend.IScorecardInstructionDto[];
	}
	export interface IScorecardEvaluatorsDto
	{
		pageTitle: string;
		isReadOnly: boolean;
		spaceId: number;
		spaceDisplayName: string;
		scorecardId: number;
		furthestSavedScorecardWizardStep: CwxBackend.ScorecardWizardStep;
		dueDate: string;
		taskTemplateId: any;
		scorecardTemplates: CwxBackend.ICwxSelectListItem[];
		evaluators: CwxBackend.IUserViewModel[];
	}
	export interface IScorecardSelectItemsDto
	{
		pageTitle: string;
		isReadOnly: boolean;
		spaceId: number;
		spaceDisplayName: string;
		scorecardId: number;
		furthestSavedScorecardWizardStep: CwxBackend.ScorecardWizardStep;
		selectedItems: number[];
	}
	export interface IScorecardSelectItemDto
	{
		id: number;
		imageUrl: string;
		title: string;
		submittedDate: string;
		state: string;
		stateHexColor: string;
		ideaType: string;
		category: string;
		department: string;
		divisionName: string;
		regionsName: string;
		companyName: string;
		countryName: string;
		employeeType: string;
		utilityOpen: number;
		utilityOpenDisplayValue: string;
		rewards: number;
		rewardsDisplayValue: string;
	}
	export interface IScorecardInstructionDto
	{
		cultureCode: string;
		title: string;
		instruction: string;
	}
	export interface IScorecardDefinitionUpdateCommand
	{
		scorecardId: number;
		instructions: CwxBackend.IScorecardInstructionDto[];
	}
	export interface IScorecardEvaluatorsUpdateCommand
	{
		scorecardId: number;
		taskTemplateId: any;
		dueDate: string;
		evaluators: CwxBackend.IUserViewModel[];
	}
	export interface IScorecardDefinitionCreateCommand
	{
		spaceId: number;
		instructions: CwxBackend.IScorecardInstructionDto[];
	}
	export interface IScorecardSelectItemsUpdateCommand
	{
		scorecardId: number;
		selectedItemIds: number[];
	}
	export enum SubmitTypes {
		SaveDraft = 0,
		SubmitResult = 1,
		AcceptTaskResult = 2,
		NextTask = 3,
		NextTaskSaveDraft = 4,
		PreviousTask = 5,
		PreviousTaskSaveDraft = 6,
		SaveAsAdmin = 7
	}
	export enum ScorecardWizardStep {
		Definition = "Definition",
		Evaluators = "Evaluators",
		SelectItems = "SelectItems"
	}
	export interface IScheduleEventViewModel
	{
		meetingParticipants: CwxBackend.IPeoplePickerViewModel;
		startDateTime: string;
		duration: number;
		usersTimeOffset: number;
		subject: string;
		messageBody: string;
		ideaId: number;
		hasGraphAccess: boolean;
		availableDurations: CwxBackend.ICwxSelectListItem[];
	}
	export interface ICheckScheduleForUsersAvailabilityDto
	{
		duration: number;
		startDateTime: string;
		usersTimeOffset: number;
		participants: string[];
	}
	export interface INewCalendarEventViewModel
	{
		startDateTime: string;
		duration: number;
		usersTimeOffset: number;
		subject: string;
		messageBody: string;
		ideaId: number;
		meetingParticipants: CwxBackend.IMeetingParticipants;
	}
	export interface ICalendarEventDto
	{
		id: string;
		subject: string;
		url: string;
		startTime: string;
		endTime: string;
	}
	export interface IMeetingParticipants
	{
		listOfPickedPersons: CwxBackend.IUserViewModel[];
	}
	export interface IConversationRequestDto
	{
		ideaId: number;
		teamsMeetingPeoplePicker: CwxBackend.IMeetingParticipantsDto;
		conversationType: CwxBackend.ConversationType;
	}
	export interface ICopyTasksToTodoModel
	{
		tasksIds: string[];
		copyScope: CwxBackend.TodoCopyScopes;
		isWorkflowTasks: boolean;
		usersTimeOffset: number;
	}
	export interface ICopyTasksToTodoResult
	{
		tasksToCopyCount: number;
		copiedTasksCount: number;
		copyResult: boolean;
	}
	export interface ICreateNewMicrosoftMeetingCommand
	{
		startDateTime: string;
		duration: number;
		usersTimeOffset: number;
		subject: string;
		messageBody: string;
		ideaId: number;
		meetingParticipants: CwxBackend.IMeetingParticipantsDto;
	}
	export interface IMeetingParticipantsDto
	{
		listOfPickedPersons: CwxBackend.IUserDto[];
	}
	export enum TodoCopyScopes {
		Selected = 0,
		All = 1,
		None = 2
	}
	export enum ConversationType {
		Chat = 0,
		Call = 1
	}
	export interface IUri
	{
		absolutePath: string;
		absoluteUri: string;
		localPath: string;
		authority: string;
		hostNameType: number;
		isDefaultPort: boolean;
		isFile: boolean;
		isLoopback: boolean;
		pathAndQuery: string;
		segments: string[];
		isUnc: boolean;
		host: string;
		port: number;
		query: string;
		fragment: string;
		scheme: string;
		originalString: string;
		dnsSafeHost: string;
		idnHost: string;
		isAbsoluteUri: boolean;
		userEscaped: boolean;
		userInfo: string;
	}
	export interface ICoAuthorViewModel
	{
		coAuthorsList: CwxBackend.ICoAuthorRow[];
		showRewardShares: boolean;
		showLineManagers: boolean;
		isLineManagerRequired: boolean;
		maxUserToPick: number;
		spaceId: number;
		ideaAuthorLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		headingOfAuthorBoxLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		infoTextInAuthorBoxLocale: CwxBackendOnboarding.ICustomLocaleViewModel;
		isGraphSearch: boolean;
	}
	export interface ICoAuthorRow
	{
		user: CwxBackend.IUserViewModel;
		rewardShare: number;
		lineManager: CwxBackend.IUserViewModel;
		isAuthor: boolean;
	}
	export interface ISubmitIdeaResponseDto
	{
		redirectUrl: string;
	}
	export interface IAIAssistantInitialDataRequest
	{
		aiFormConfigurationId: number;
	}
	export interface IAIAssistantViewModel
	{
		assistantId: any;
		launchButtonText: string;
		spaceConfigurationId: number;
		formConfigurationId: number;
		formId: number;
		formFieldId: number;
		isAIEnabled: boolean;
		fieldHtmlId: string;
		isEnabledForFormField: boolean;
		isEnabledForForm: boolean;
	}
	export interface IAIAssistantDataResponse
	{
		openingButtons: any[];
		welcomeMessage: string;
		userDisplayName: string;
		userAvatarUrl: string;
		cultureCode: string;
	}
	export interface IGetAssistantResponseRequest
	{
		chatSessionId: any;
		content: string;
	}
	export interface IRegenerateAssistantResponseRequest
	{
		chatSessionId: any;
	}
	export interface IAiAssistantGetConversationHistoryRequest
	{
		chatSessionId: any;
	}
	export interface IAiAssistantMessageResponse
	{
		content: string;
		isFinalResult: boolean;
		formFieldValues: CwxBackend.IFormFieldGeneratedValueViewModel[];
	}
	export interface IChatMessage
	{
		createdAt: string;
		isFromAssistant: boolean;
		content: string;
		rawContent: string;
		formFieldValues: { [key:string]: string };
		isFinalResult: boolean;
	}
	export interface IOpeningButtonViewModel
	{
		id: number;
		label: string;
		prompt: CwxBackend.IPromptViewModel;
	}
	export interface IPromptViewModel
	{
		formId: number;
		formFieldId: number;
		text: string;
		welcomeMessage: string;
		resultJsonSchema: string;
		availablePromptPlaceholders: any[];
	}
	export interface IFormFieldGeneratedValueViewModel
	{
		name: string;
		value: string;
	}
	export interface IAiAssistantConversationHistoryResponse
	{
		messages: CwxBackend.IChatMessage[];
	}
	export interface IAiGetOrCreateChatSessionRequest
	{
		formConfigurationId: number;
		openingButtonId: number;
		ideaId: number;
		forceCreateNewSession: boolean;
		sessionId: any;
	}
	export interface IChatSessionId extends CwxBackend.IGuidIdentifier
	{
	}
}
export namespace CwxBackendOnboarding {
	export interface IVMOnboardingUserData
	{
		userFields: CwxBackendOnboarding.IVMOnboardingUserFieldValue[];
		multipleChoiceLists: CwxBackendOnboarding.IVMOnboardingMultipleChoiceListValue[];
		regions: CwxBackendOnboarding.IRegionViewModel[];
		countries: CwxBackendOnboarding.ICountryGridItemViewModel[];
		userId: string;
		userImageId: number;
		filledEmailTemplateContent: string;
		isInvitationEnabled: boolean;
		invitingDailyLimit: number;
	}
	export interface IVMOnboardingUserFieldValue extends CwxBackendOnboarding.IVMContactDataTemplateValue
	{
		order: number;
		type: CwxBackend.UserFieldType;
	}
	export interface IVMOnboardingMultipleChoiceListValue extends CwxBackendOnboarding.IVMUserInterestGroup
	{
		order: number;
	}
	export interface IRegionViewModel
	{
		id: number;
		nameId: string;
		localizableName: CwxBackendOnboarding.ICustomLocaleViewModel;
		nameInCurrentCulture: string;
	}
	export interface ICountryGridItemViewModel
	{
		id: number;
		nameId: string;
		factor: number;
		canBeDeleted: boolean;
		nameLocale: any;
		nameInCurrentCulture: string;
	}
	export interface IVMContactDataTemplateValue
	{
		name: string;
		contactDataTemplateId: number;
		value: string;
		userTagValues: CwxBackend.ITagViewModel[];
	}
	export interface IVMUserInterestGroup
	{
		id: number;
		name: string;
		options: CwxBackendOnboarding.IVMUserInterestOption[];
		isEditable: boolean;
		isIncludedInReports: boolean;
		selectedOptions: CwxBackendOnboarding.IVMUserInterestOption[];
	}
	export interface IVMUserInterestOption
	{
		id: number;
		name: string;
		selected: boolean;
	}
	export interface ICustomLocaleViewModel
	{
		localeId: any;
		texts: { [key:string]: string };
		text: string;
	}
	export interface IInviteNewUserViewModel
	{
		emails: string;
		sendCopyToMySelf: boolean;
		mailBody: string;
		filledEmailTemplateContent: string;
		isInvitingActive: boolean;
		invitingDailyLimit: number;
	}
}
